const advancements = [
    {
        id: 'fishery',
        name: 'Fishery',
        level: 1,
        land: 'water',
        image: ["M 11.43,8.2549999 C 8.0406211,7.4865312 4.5538666,1.3981119 1.27,6.3499999 4.6399853,11.315049 8.0428921,5.2064776 11.43,4.445 Z"]
    },
    {
        id: 'canoes',
        name: 'Canoes',
        level: 1,
        land: 'water',
        image: ["m 1.27,5.0799999 c 0.035254,1.1267074 0.3067896,2.0829129 1.27,2.54 h 7.62 c 0.796942,-0.4486596 1.345551,-1.2922421 1.27,-2.54 z"]
    },
    {
        id: 'forestry',
        name: 'Forestry',
        level: 1,
        land: 'forest',
        image: [
            "M 2.54,8.8899999 3.81,1.27 5.0799999,8.8899999 h -0.9525 V 11.43 H 3.4925 V 8.8899999 Z",
            "m 5.3975,10.16 v 1.27 h 0.635 v -1.27 z",
            "m 10.16,11.43 0,-0.635 H 9.525 l -1e-7,0.635 z",
            "M 7.6199999,11.43 7.62,8.89 H 6.35 L 7.9375,5.08 9.525,8.89 h -1.27 l -1e-7,2.54 z"
        ]
    },
    {
        id: 'primitive-mine',
        name: 'Primitive mine',
        level: 1,
        land: 'hills',
        image: [
            "M 8.5724999,2.2225 C 4.1275,2.54 2.54,4.1275 2.2225,8.5724999 l 0.3175,0.3175 C 3.175,4.7625 4.7625,3.175 8.8899999,2.54 Z",
            "M 4.1275,4.7625 9.8424999,10.4775 10.4775,9.8424999 4.7625,4.1275 Z"
        ]
    },
    {
        id: 'quarry',
        name: 'Quarry',
        level: 1,
        land: 'hills',
        image: [
            "M 1.27,2.54 H 3.81 V 5.7149999 H 4.7624999 V 10.16 H 11.43",
            "M 5.7149999,10.16 V 8.2549999 h 1.905 V 10.16",
            "M 8.5724999,10.16 V 8.255 H 10.4775 v 1.905",
            "M 6.985,8.255 V 6.0325 h 2.54 V 8.255 Z"
        ]
    },
    {
        id: 'cultivation',
        name: 'Cultivation',
        level: 1,
        land: 'plains',
        image: [
            "M 1.27,9.525 H 11.43",
            "M 3.81,9.525 V 4.4449999",
            "m 3.81,6.9849999 -1.27,-1.27",
            "m 3.81,6.9849999 1.2699999,-1.27",
            "M 8.8899999,9.525 V 3.175",
            "m 8.8899999,5.7149999 -1.27,-1.27",
            "M 8.8899999,6.9849999 10.16,5.7149999"
        ]
    },
    {
        id: 'fishing-village',
        name: 'Fishing village',
        level: 1,
        land: 'coast',
        image: [
            "M 1.27,7.6199999 6.3499999,10.16",
            "M 6.3499999,7.6199999 V 3.81 L 3.81,2.54 1.27,3.81 H 6.3499999 1.27 V 7.6199999 H 11.43 V 10.16",
            "m 5.0799999,7.6199999 v 1.905",
            "M 8.8899999,7.6199999 V 10.16",
            "m 6.3499999,10.16 c 0.8192354,-0.3983511 1.6625026,-0.4477167 2.54,0 0.7544704,0.327462 1.5495931,0.510534 2.5400001,0"
        ]
    },
    {
        id: 'building',
        name: 'Building',
        level: 1,
        land: 'plains',
        image: [
            "m 2.54,5.3975 v 5.08 h 7.62 v -5.08 z",
            "m 1.905,6.0325 1.5875,-3.175 h 5.715 l 1.5875,3.175",
            "m 5.08,10.4775 0,-1.905 h 2.54 l 0,1.905",
            "M 6.3499999,8.5724999 V 10.4775",
            "M 3.81,6.35 V 7.62 H 5.715 V 6.35 Z",
            "M 6.985,6.35 V 7.62 H 8.89 V 6.35 Z"
        ]
    },
    {
        id: 'herded-sheep',
        name: 'Herded sheep',
        level: 1,
        land: 'plains',
        image: [
            "m 1.9050001,2.2225 0.635,2.2225 h 0.635 L 3.81,2.2225 Z",
            "m 1.9050001,2.2225 -0.635,-0.3175 -0.3175,0.3175 0.3175,0.3175 z",
            "M 3.81,2.2225 4.445,1.905 4.7625,2.2225 4.445,2.54 Z",
            "M 3.4925,3.175 H 8.255 c 0.3749572,0.5087145 0.4694754,1.1910359 0,2.2225 H 2.8575001 V 4.445",
            "M 3.4925,5.3975 V 6.35",
            "M 7.62,5.3975 V 6.35",
            "M 10.795,6.985 10.16,9.2075 H 9.5249999 L 8.89,6.985 Z",
            "M 10.795,6.985 11.43,6.6675 11.7475,6.985 11.43,7.3025 Z",
            "M 8.89,6.985 8.255,6.6675 7.9375,6.985 8.255,7.3025 Z",
            "M 9.2075,7.9375 H 4.445 c -0.3749572,0.5087145 -0.4694754,1.191036 0,2.2225 H 9.8424999 V 9.2075",
            "m 9.2075,10.16 v 0.9525",
            "m 5.08,10.16 v 0.9525"
        ]
    },
    {
        id: 'soldiers',
        name: 'Soldiers',
        level: 1,
        land: 'plains',
        requirements: [['city', 'forge'], ['metropolis', 'forge']],
        image: [
            "M 1.27,5.08 H 3.175 V 6.35 L 2.2225,7.9375 1.27,6.35 Z",
            "m 4.7624997,6.6672415 2e-7,2.2227585 h -0.635 V 7.3025 H 3.175 V 8.89 H 2.54 V 7.62",
            "M 2.54,5.08 V 4.445 h 2.2224999 l -2e-7,0.6346307",
            "M 2.8575,4.445 V 2.8575001 H 4.4449999 V 4.445",
            "m 4.7625,5.3975001 1.27,-1.27 H 6.35 v 0.3175 l -1.5875,1.5875 0.3175,0.3175 -0.3175,0.3175 -0.3175,-0.3175 -0.3175,0.3175 -0.3175,-0.3175 0.3175,-0.3175 -0.3175,-0.3175 0.3175,-0.3175 0.3175,0.3175 z",
            "m 6.35,6.0325 h 1.905 v 1.27 L 7.3025,8.89 6.35,7.3025 Z",
            "m 9.8424997,7.6197415 2e-7,2.2227585 h -0.635 V 8.255 H 8.255 V 9.8425 H 7.62 v -1.27",
            "m 7.62,6.0325 v -0.635 h 2.2224999 l -2e-7,0.6346307",
            "M 7.9375,5.3975 V 3.8100001 H 9.5249999 V 5.3975",
            "m 9.8425,6.3500001 1.27,-1.27 H 11.43 v 0.3175 l -1.5875,1.5875 0.3175,0.3175 -0.3175,0.3175 -0.3175,-0.3175 -0.3175,0.3175 -0.3175,-0.3175 0.3175,-0.3175 -0.3175,-0.3175 0.3175,-0.3175 0.3175,0.3175 z"
        ]
    },
    {
        id: 'advanced-mine',
        name: 'Advanced mine',
        level: 1,
        land: 'mountain',
        requirements: [['university', 'underground-mine']],
        image: [
            "m 4.1273963,3.7418906 c -0.06103,0.020283 -0.1219044,0.04018 -0.1829345,0.060461 C 2.8837004,4.1488729 1.8251102,4.4972604 0.76274395,4.8425985 1.356609,6.233113 1.9451686,7.6242101 2.5367958,9.0149538 4.8203641,8.8964943 7.1036306,8.7783531 9.3875405,8.6614869 10.221625,7.841509 11.057145,7.0220587 11.893848,6.2027222 11.053014,5.5538697 10.21017,4.9056376 9.3699703,4.256588 7.6225558,4.0846419 5.8749371,3.9135271 4.1273963,3.7418906 Z",
            "m 4.2286844,4.6079895 a 0.31998721,0.15698094 0 0 0 -0.166398,0.026355 L 2.1430236,5.2622134 A 0.31998721,0.15698094 0 0 0 2.0071146,5.4234438 L 3.286623,8.5633037 A 0.31998721,0.15698094 0 0 0 3.6411234,8.6883608 L 8.4428973,8.3741681 a 0.31998721,0.15698094 0 0 0 0.2537315,-0.095602 l 1.5988682,-1.883089 a 0.31998721,0.15698094 0 0 0 -0.05323,-0.162264 L 8.3224913,5.1340558 A 0.31998721,0.15698094 0 0 0 8.1571267,5.0839297 L 4.3165343,4.6121236 a 0.31998721,0.15698094 0 0 0 -0.08785,-0.00414 z",
            "M 4.2400513,5.5097412 3.279903,5.8239339 4.5599283,8.3359251 7.7602497,8.0217324 8.7203977,6.6088989 7.4403727,5.8239339 Z",
            "M 5.2797811,6.566524 C 4.8610676,6.5665137 5.0436719,6.8326025 5.2193195,7.0956907 l 0.350883,0.6883302 C 6.2903788,7.7347399 6.5715121,7.4827171 6.6926148,7.156669 7.05442,6.8847273 6.2473401,6.6131119 5.7272989,6.6228515 5.5323073,6.5837795 5.3865119,6.5665265 5.2797811,6.566524 Z"
        ]
    },
    {
        id: 'watchtower',
        name: 'Watchtower',
        level: 1,
        land: 'mountain',
        image: [
            "m 4.1275,5.08 h 4.445",
            "m 4.445,2.54 v 0.635 h 1.5875 l 0,-0.635 z",
            "m 6.6675,2.54 0,0.635 H 8.255 l 0,-0.635 z",
            "M 4.1274999,5.0799999 3.81,3.81 V 2.54 H 3.175 l 3.1749999,-1.27 3.175,1.27 h -0.635 V 3.81 H 3.81 8.8899999 l -0.3175,1.2699999 z",
            "m 4.4449999,11.43 0.635,-6.3500001 h 2.54 l 0.635,6.3500001",
            "m 7.6199999,5.0799999 -2.8575,2.8575 3.4925,3.4925001 h -3.81 l 3.4925,-3.4925001 -2.8575,-2.8575"
        ]
    },
    {
        id: 'bridge',
        name: 'Bridge',
        level: 1,
        land: 'river',
        image: [
            "m 1.27,8.8899999 1.27,1e-7 c 1.27,-3.175 6.35,-3.175 7.62,0 l 1.27,-1e-7 v -3.81 H 1.27 Z"
        ]
    },
    {
        id: 'watermill',
        name: 'Watermill',
        level: 1,
        land: 'river',
        requirements: [['sawmill', 'bridge']],
        image: [
            "m 8.1597497,6.6675007 a 1.80975,1.80975 0 0 1 -1.80975,1.80975 1.80975,1.80975 0 0 1 -1.80975,-1.80975 1.80975,1.80975 0 0 1 1.80975,-1.80975 1.80975,1.80975 0 0 1 1.80975,1.80975 z",
            "m 1.905,8.2549999 c 0.333561,-0.02929 0.4529727,-0.2176684 1.27,0 0.3932339,0.090298 0.8081396,0.1155809 1.2699999,0 0.5350373,-0.111704 0.9030594,-0.056393 1.27,0 0.5395692,-0.00673 0.334654,-0.00507 1.27,0 0.4092109,-0.1129794 0.8265889,-0.1606224 1.27,0 0.3986454,0.1728156 0.8388694,0.054581 1.27,0 H 10.795",
            "M 6.350018,6.6674822 6.3499682,4.2675987 6.350018,6.6674822 7.5501632,4.5888846 6.350018,6.6674822 8.4285812,5.4673026 6.350018,6.6674822 8.7499338,6.6675026 6.350018,6.6674822 8.4285772,7.8676936 6.350018,6.6674822 7.5501632,8.7461147 6.3499997,6.6675007 6.349973,9.0674025 6.3499997,6.6675007 5.1497722,8.7461113 6.3499997,6.6675007 4.2713542,7.8676936 6.3499997,6.6675007 3.9500651,6.6675026 6.3499995,6.6675005 4.2713542,5.4673026 6.3499995,6.6675005 5.1497722,4.5888846 Z",
            "m 10.16,8.2549999 v -2.2225 l -0.9525001,-0.9525 V 3.81 H 3.4925",
            "M 3.4925,8.2549999 V 3.81 l 2.8574999,-1.5875 2.8575,1.5875 v 4.4449999"
        ]
    },
    {
        id: 'windmill',
        name: 'Windmill',
        level: 1,
        land: 'hills',
        requirements: [['sawmill', 'building']],
        image: [
            "m 8.2700847,8.6693837 c 0.09318,0.6252191 0.19768,1.1794828 0.3021804,1.4929833",
            "m 7.9060789,5.1909783 c 0.02199,0.067655 0.033037,0.1371738 0.031186,0.2088891 0,0.2591983 0.0529,0.941601 0.1371084,1.7233093",
            "M 6.2144003,3.9175218 C 6.2609215,3.8826776 6.306194,3.8476536 6.3497651,3.8123674 6.6359501,4.036571 6.9813588,4.2506884 7.276822,4.4733119",
            "m 4.754058,5.6433338 c 0.00538,-0.1010869 0.00821,-0.1835745 0.00821,-0.2434664 0,-0.3509687 0.295266,-0.6453068 0.6642505,-0.9233069",
            "M 4.1272651,10.162367 C 4.3151659,9.5986646 4.5030668,8.2565456 4.6251567,7.1231764",
            "m 1.9047652,10.797367 c 2.9355972,-0.8326456 5.8979996,-0.8605918 8.8899998,0",
            "M 6.798778,5.8488802 6.1252588,6.5223994 8.5948293,8.9919699 9.2683485,8.3184507 3.4311821,2.4812842 4.1047013,1.807765 6.5742716,4.2773354 5.9007524,4.9508546",
            "M 6.798778,4.9508547 7.4722972,5.6243739 9.9418677,3.1548035 9.2683485,2.4812843 3.431182,8.3184507 2.7576628,7.6449315 5.2272332,5.1753611 5.9007524,5.8488803"
        ]
    },
    {
        id: 'crayfishery',
        name: 'Crayfishery',
        level: 1,
        land: 'river',
        image: [
            "m 3.2004729,9.8424999 c -0.6719982,-1.292813 0,-1.9049999 0,-3.81 C 3.0555134,5.5127239 3.2566427,4.201882 3.8354728,3.4925 c 1e-7,0.2012458 1e-7,0.4108446 0,0.635 -0.1519182,0.664461 -0.6313644,1.62061 0,1.5874999 l 1e-7,1e-7 -1e-7,0.3174999 c 0.025624,0.1510853 -0.2020466,0.4450725 0.3175,0.3175 -0.6154799,-1.2321809 -0.1783555,-1.9860467 0,-2.8574999 0.1079136,-0.2419851 -0.1681899,0.7627632 0.635,2.8574999 0.6350001,1.2700001 10e-8,2.5400001 -0.3175,3.175 -0.7239754,0.4955251 -0.9211187,0.3081714 -1.2699999,0.3175 z",
            "M 6.0579728,10.795 C 6.0247659,8.0624779 6.2716285,4.3606579 5.7404729,2.2225",
            "M 6.0579728,10.795 C 6.2722859,8.2452639 6.6648255,5.1639521 7.0104729,2.2225",
            "m 9.5249999,9.8425 c 0.6719981,-1.292813 0,-1.9049999 0,-3.81 0.14496,-0.519776 -0.05617,-1.8306179 -0.6349998,-2.5399999 -10e-8,0.2012458 -10e-8,0.4108446 0,0.635 0.1519182,0.664461 0.6313648,1.62061 0,1.5874999 l -10e-8,1e-7 10e-8,0.3174999 c -0.025624,0.1510853 0.2020466,0.4450725 -0.3175,0.3175 0.6154799,-1.2321809 0.1783555,-1.9860467 0,-2.8574999 C 8.4645865,3.250515 8.74069,4.2552633 7.9375,6.35 c -0.635,1.2700001 0,2.5400001 0.3175001,3.175 0.7239754,0.495525 0.9211187,0.3081714 1.2699998,0.3175 z",
        ]
    },
    {
        id: 'radio-tower',
        name: 'Radio tower',
        level: 2,
        land: 'mountain',
        requirements: [['watchtower', 'semi-conductor-factory']],
        ancestor: 'watchtower',
        image: [
            "M 5.08,10.16 5.7149999,2.54 h 1.27 L 7.62,10.16",
            "M 3.81,10.16 H 8.8899999",
            "m 5.0799999,10.16 2.2225,-2.5400001 -1.905,-1.905 1.5875,-1.9049999 -1.27,-1.27 h 1.27 l -1.27,1.27 1.5875,1.9049999 -1.905,1.905 2.2225,2.5400001",
            "M 6.3499999,2.54 V 1.27",
            "M 5.08,3.4925001 C 5.171107,3.8943234 5.105816,4.3132286 4.7625,4.7625",
            "M 7.62,4.1275 C 7.4714413,4.7686177 7.7821341,5.0630782 8.3090908,5.1942961",
            "m 5.0799999,4.1274999 0.3175,0.3175",
            "m 7.6199999,4.7624999 -0.3175,0.3175",
            "m 7.6199999,6.0324999 v 0.9525",
            "m 7.6199999,6.3499999 h -0.3175",
            "M 6.6674999,1.905 V 2.54",
            "m 4.7624999,6.6674999 v 1.27",
            "m 4.7624999,7.3024999 h 0.635"
        ]
    },
    {
        id: 'steel-bridge',
        name: 'Steel bridge',
        level: 2,
        land: 'river',
        requirements: [['bridge', 'forge']],
        ancestor: 'bridge',
        image: [
            "M 1.5875001,7.6200001 11.1125,7.62 9.525,4.445 7.9375,7.62 6.35,4.445 4.7625,7.62 3.1750001,4.445 1.5875001,7.62",
            "m 2.2225001,6.35 0.9525,1.27 L 4.1275,6.35 4.7625,7.62 5.3975,6.35 6.35,7.62 7.3025,6.35 7.9375,7.62 8.5725,6.35 9.525,7.62 10.4775,6.35",
            "M 3.1750001,4.445 H 9.525",
            "M 0.9525001,7.62 H 11.7475",
            "M 4.7625,4.445 V 7.62",
            "M 7.9375,4.445 V 7.62",
            "m 3.175,4.4449999 v 3.175",
            "m 9.5249999,4.4449999 v 3.175",
            "m 6.3499999,4.4449999 v 3.175",
            "m 0.95249999,7.6199999 v 1.27 L 1.5875,8.89 V 7.62",
            "m 11.7475,7.6199999 v 1.27 l -0.635,1e-7 V 7.62",
            "m 6.0324999,7.6199999 v 1.27 h 0.635 v -1.27"
        ]
    },
    {
        id: 'underground-mine',
        name: 'Underground mine',
        level: 2,
        land: 'hills',
        requirements: [['primitive-mine', 'forestry']],
        ancestor: 'primitive-mine',
        image: [
            "m 7.3024999,10.16 c 0.0812,-0.1964354 -0.3082755,-0.101842 0.3175,-0.6350001 0.3654553,-0.016813 0.7726892,-0.1404746 0.9525,0.3175 L 8.8899999,10.16",
            "M 3.81,3.175 2.54,10.16 h 7.62 L 8.89,3.175 Z",
            "m 1.905,10.16 1.27,-6.985 h 6.35 l 1.27,6.985",
            "M 2.8575001,2.54 V 3.175 H 9.8425 V 2.54 Z"
        ]
    },
    {
        id: 'ships',
        name: 'Ships',
        level: 2,
        land: 'water',
        requirements: [['canoes', 'forestry'], ['canoes', 'sawmill']],
        ancestor: 'canoes',
        image: [
            "m 1.27,7.62 1.27,2.54 h 7.62 l 1.27,-2.54 z",
            "M 5.08,7.62 V 2.5400001 l -2.5399999,3.81 H 5.08",
            "M 8.89,7.62 V 2.5400001 l -2.5399999,3.81 H 8.89"
        ]
    },
    {
        id: 'farm',
        name: 'Farm',
        level: 2,
        land: 'plains',
        requirements: [['cultivation', 'building'], ['cultivation', 'city'], ['cultivation', 'metropolis']],
        ancestor: 'cultivation',
        image: [
            "M 6.3499999,1.27 1.27,6.3499999 l 2.54,2.54 L 8.8899999,3.81 Z",
            "M 3.81,8.8899999 V 11.43 h 6.35 V 3.81 H 8.8899999",
            "M 1.905,6.9849999 6.9849999,1.905 7.6199999,2.54 2.54,7.6199999 3.175,8.2549999 8.2549999,3.175",
            "m 9.2074999,3.81 v 7.62 h -0.9525 V 4.4449999 l -0.9525,0.9525 V 11.43 h -0.9525 V 6.3499999 l -0.9525,0.9525 V 11.43 h -0.9525 V 8.2549999",
            "m 9.8425,3.81 0,-2.2225 H 6.6674999 l 0.635,0.635 H 9.8425 V 3.175 H 8.2549999",
            "M 5.7149999,1.905 H 2.54 l -1.27,1.27 1.5875,1.5874999 0.635,-0.635 L 1.905,2.54 2.54,1.905 4.1274999,3.4925 4.7624999,2.8575 3.81,1.905"
        ]
    },
    {
        id: 'city',
        name: 'City',
        level: 2,
        land: 'plains',
        requirements: [['quarry', 'building']],
        ancestor: 'building',
        image: [
            "M 1.9050001,9.2075 V 6.6674999 l 1.27,-0.9525 0.9524999,0.9525 V 9.2075 H 5.715 V 7.6199999 l 1.27,-0.635 h 1.5875 l 0.9525001,0.635 V 9.2075 5.3974999 l 0.6349999,-1.5875 0.635,1.5875 V 9.2075 Z",
            "m 3.81,6.3499999 v -0.9525 l 1.5875,-0.635 1.27,0.635 v 1.5875",
            "m 7.62,6.9849999 v -0.9525 l 0.635,-0.635 0.635,0.635 v 1.27"
        ]
    },
    {
        id: 'livestock',
        name: 'Livestock',
        level: 2,
        land: 'plains',
        requirements: [['herded-sheep', 'building'], ['herded-sheep', 'city'], ['herded-sheep', 'metropolis']],
        ancestor: 'herded-sheep',
        image: [
            "m 3.8100001,5.7149999 -0.635,-1.5875 H 5.08 l -0.635,1.5875 z",
            "M 5.08,4.1274999 5.3975,3.175",
            "M 3.1750001,4.1274999 2.8575001,3.175",
            "M 4.7625,5.0799999 H 8.89 v 3.175 H 8.5725 v -0.9525 H 5.08 v 0.9525 H 4.7625 v -0.9525 l -0.635,-1.5875",
            "M 1.5875001,9.525 V 6.3499999 H 11.1125 V 9.525 Z",
            "m 3.175,6.3499999 v 3.175 c 0,0 1.5874999,0 1.5874999,0 v -3.175 h 1.5875 v 3.175 h 1.5875 v -3.175 h 1.5875 v 3.175",
            "M 1.2700001,9.525 H 11.43"
        ]
    },
    {
        id: 'port',
        name: 'Port',
        level: 2,
        land: 'coast',
        requirements: [['fishing-village', 'ships'], ['fishing-village', 'steamship'], ['fishing-village', 'armada']],
        ancestor: 'fishing-village',
        image: [
            "m 2.54,7.6199999 1.27,1.27 c 0.9145328,-0.4718672 1.7468814,-0.3723158 2.5399999,0 0.8192357,0.3983516 1.6625031,0.4477165 2.54,0 l 0.9525,-1.27 z",
            "m 5.0799999,7.6199999 v -2.54 L 3.81,6.9849999 h 1.2699999",
            "m 7.9374999,7.6199999 v -2.8575 l -0.9525,2.2225 h 0.9525",
            "M 1.27,7.9374999 H 2.8575",
            "M 9.5249999,7.9374999 H 11.43",
            "m 10.795,7.9374999 v -2.2225 H 8.8899999 v 1.905 -1.905 l 0.9525,-0.9525 0.9525001,0.9525",
            "m 1.5875,7.9374999 v -2.2225 h 3.1749999",
            "m 5.0799999,5.7149999 h 0.635 v 1.905",
            "M 1.27,8.8899999 H 3.81",
            "M 8.8899999,8.8899999 H 11.43",
            "m 5.7149999,6.3499999 h 1.5875",
            "m 7.9374999,6.3499999 h 0.9525",
            "m 3.175,8.2549999 c -0.4144647,0.100093 -0.8371105,0.010225 -1.27,-0.3175",
            "m 1.905,7.9374999 v -0.3175"
        ]
    },
    {
        id: 'sawmill',
        name: 'Sawmill',
        level: 2,
        land: 'forest',
        requirements: [['forge', 'forestry']],
        ancestor: 'forestry',
        image: [
            "m 6.3499503,2.1498048 -0.1171875,0.904785 a 3.2999998,3.2999998 0 0 1 0.1171875,-0.00439 3.2999998,3.2999998 0 0 1 0.7407228,0.083985 z m 0.7407228,0.984375 A 3.2999998,3.2999998 0 0 1 7.8978017,3.4359375 L 7.4368642,2.2928711 Z M 7.8978017,3.4359375 A 3.2999998,3.2999998 0 0 1 8.599462,3.9354493 L 8.450048,2.712793 Z M 8.599462,3.9354493 A 3.2999998,3.2999998 0 0 1 9.1473135,4.5995118 L 9.3196767,3.3802735 Z M 5.2630363,2.2928711 5.3836418,3.1947265 A 3.2999998,3.2999998 0 0 1 6.2322746,3.0545898 Z M 5.3836418,3.1947265 4.2498526,2.712793 4.6009268,3.5545898 a 3.2999998,3.2999998 0 0 1 0.782715,-0.3598633 z m -2.003418,0.185547 0.5551758,0.720703 a 3.2999998,3.2999998 0 0 1 0.665039,-0.5463867 z m 0.5551758,0.720703 -1.2226563,0.1489258 0.7246093,0.553711 A 3.2999998,3.2999998 0 0 1 3.9353996,4.1009765 Z M 3.4373526,4.8036133 2.2928213,5.263086 3.1341301,5.6092773 A 3.2999998,3.2999998 0 0 1 3.4373526,4.8036133 Z M 3.1341301,5.6092773 2.149755,6.35 3.0545401,6.4671875 A 3.2999998,3.2999998 0 0 1 3.0501456,6.35 3.2999998,3.2999998 0 0 1 3.1341301,5.6092773 Z M 9.9871572,4.2499023 9.1473135,4.6 a 3.2999998,3.2999998 0 0 1 0.357422,0.7836915 z M 9.5047355,5.3836915 a 3.2999998,3.2999998 0 0 1 0.142578,0.8496093 L 10.407079,5.263086 Z m 0.142578,0.8496093 A 3.2999998,3.2999998 0 0 1 9.6497635,6.35 3.2999998,3.2999998 0 0 1 9.565779,7.0907228 L 10.550154,6.35 Z m -0.081543,0.857422 A 3.2999998,3.2999998 0 0 1 9.262548,7.8963868 L 10.407079,7.436914 Z M 9.262548,7.8963868 A 3.2999998,3.2999998 0 0 1 8.764501,8.5990235 L 9.9871572,8.4500978 Z M 8.764501,8.5990235 A 3.2999998,3.2999998 0 0 1 8.099462,9.1454103 L 9.3196767,9.3197265 Z M 3.0545401,6.4676758 2.2928213,7.436914 3.1946768,7.3163085 A 3.2999998,3.2999998 0 0 1 3.0545401,6.4676758 Z M 3.1946768,7.3163085 2.7127433,8.4500978 3.5545401,8.0990235 A 3.2999998,3.2999998 0 0 1 3.1946768,7.3163085 Z M 3.5545401,8.0995118 3.3802238,9.3197265 4.1009268,8.7645508 A 3.2999998,3.2999998 0 0 1 3.5545401,8.0995118 Z M 4.1009268,8.7645508 4.2498526,9.987207 4.8035636,9.2625978 A 3.2999998,3.2999998 0 0 1 4.1009268,8.7645508 Z M 4.8035636,9.2625978 5.2630363,10.407129 5.6092276,9.5658203 A 3.2999998,3.2999998 0 0 1 4.8035636,9.2625978 Z m 0.805664,0.3032225 0.7407227,0.9843747 0.1171875,-0.9047847 a 3.2999998,3.2999998 0 0 1 -0.1171875,0.0044 3.2999998,3.2999998 0 0 1 -0.7407227,-0.083985 z m 2.4897461,-0.42041 A 3.2999998,3.2999998 0 0 1 7.3162587,9.5052735 L 8.450048,9.987207 Z M 7.3162587,9.5052735 A 3.2999998,3.2999998 0 0 1 6.4676261,9.6454103 l 0.9692381,0.7617187 z",
            "m 7.3024999,6.3499999 a 0.95249999,0.95249999 0 0 1 -0.9525,0.9525 0.95249999,0.95249999 0 0 1 -0.9525,-0.9525 0.95249999,0.95249999 0 0 1 0.9525,-0.9525 0.95249999,0.95249999 0 0 1 0.9525,0.9525 z"
        ]
    },
    {
        id: 'glass-furnace',
        name: 'Glass furnace',
        level: 2,
        land: 'hills',
        requirements: [['quarry', 'forge']],
        ancestor: 'quarry',
        image: [
            "M 8.2520179,3.5051872 C 8.3955903,5.8081046 10.474219,6.4762944 10.474621,7.3152903 10.619634,9.7639254 8.0702616,10.52923 6.5291256,9.5451285 7.0311669,9.1035622 7.3505177,8.4255015 7.2965207,7.5137278 7.296321,7.0968911 6.783528,6.7214687 6.249556,6.1675569 6.8388783,5.5808423 7.5303232,4.808005 7.6174312,3.5051872 Z",
            "m 8.2522245,3.5053937 v -0.635 h -0.635 v 0.635",
            "M 7.2997244,7.5667479 C 7.2993227,6.7277519 5.2207969,6.0596654 5.0772245,3.756748 h -0.635 C 4.2899353,6.0344393 2.2889369,6.6940176 2.2197239,7.5667479 c -2.86e-4,3.5606531 5.287073,3.4965451 5.0800005,0 z",
            "m 5.0772245,3.756748 v -0.635 h -0.635 v 0.635",
            "m 6.2495561,6.1675567 c 1.2006854,2.6873079 0.056886,2.0846261 0.2795696,3.3775716",
            "M 3.787129,7.1140012 C 3.3070317,7.2507816 3.0855293,7.5006023 3.1263119,8.2521828"
        ]
    },
    {
        id: 'stronghold',
        name: 'Stronghold',
        level: 2,
        land: 'plains',
        requirements: [['soldiers', 'quarry']],
        ancestor: 'soldiers',
        image: [
            "M 5.3974999,10.16 V 8.2549999 C 6.35,7.62 6.35,7.62 7.3024999,8.2549999 V 10.16",
            "M 6.35,5.0799999 V 2.54 H 4.7625 l 0,1.27 1.5875,0",
            "M 2.4032197,10.16 H 10.658219 V 5.0799999 H 9.70572 v 0.635 h -0.9525 v -0.635 h -0.9525 v 0.635 h -0.9525 v -0.635 h -0.9525 v 0.635 h -0.9525 v -0.635 H 3.9907197 v 0.635 h -0.9525 v -0.635 h -0.9525 V 10.16 Z"
        ]
    },
    {
        id: 'tanks',
        name: 'Tanks',
        level: 2,
        land: 'plains',
        requirements: [['factory', 'soldiers']],
        ancestor: 'soldiers',
        image: [
            "m 2.8575,6.985 h 6.985 c 0.362781,0.3921065 0.480395,0.8053159 0,1.27 h -6.985 c -0.480395,-0.4646841 -0.362781,-0.8778935 0,-1.27 z",
            "m 2.5400001,7.3025 h -0.635 V 5.715 l 0.635,-0.9525 H 7.62 L 8.5725,5.715 H 10.16 L 10.795,6.35 V 7.3025 H 10.16",
            "M 7.9375,5.08 H 11.43 V 5.3975 H 8.255",
            "M 3.8100001,4.7625 4.1275,4.445 h 1.905 L 6.35,4.7625"
        ]
    },
    {
        id: 'kelp-farm',
        name: 'Kelp farm',
        level: 2,
        land: 'water',
        requirements: [['university', 'port']],
        ancestor: 'fishery',
        image: [
            "m 1.27,8.8899999 2.54,-0.3175 1.9049999,0.3175 1.27,-0.3175 0.635,0.3175 2.8575001,-0.3175 0.9525,0.3175",
            "m 3.81,8.5724999 c -0.029339,-0.3480167 -0.1485409,-0.5677397 0,-1.27 0.151797,-0.5451955 0.024001,-0.6710014 0,-0.9525 -0.098235,-0.4626273 -0.1433569,-0.9040094 0,-1.27 0.099227,-0.4167267 0.041578,-0.6765779 0,-0.9525",
            "m 5.7149999,8.8899999 c 0.043139,-0.5155004 0.1410551,-1.0251268 0,-1.5875 -0.1792909,-0.5428606 -0.1090707,-0.9193805 0,-1.27 0.2250695,-0.8734723 0.1062697,-1.0592061 0,-1.27",
            "m 7.9374999,8.8899999 c -0.052608,-0.339161 -0.1761287,-0.5648608 0,-1.27 0.045038,-0.2574496 0.096819,-0.5059075 0,-0.9525 -0.1491312,-1.1629744 -0.028355,-1.1788414 0,-1.5875 0.034889,-0.4843894 0.1452375,-1.1008323 0,-1.2699999",
            "m 10.16,8.5724999 c 0.02167,-0.5074988 0.111607,-0.9467262 0,-1.5875 -0.06033,-0.4434418 -0.08483,-0.8749438 0,-1.27 0.03693,-0.5021491 0.0593,-0.9315091 0,-0.9525"
        ]
    },
    {
        id: 'observatory',
        name: 'Observatory',
        level: 2,
        land: 'mountain',
        requirements: [['watchtower', 'university']],
        ancestor: 'watchtower',
        image: [
            "M 6.35,4.9214567 A 5.0799999,5.0799999 0 0 0 1.2702068,10.00125 H 11.429793 A 5.0799999,5.0799999 0 0 0 6.35,4.9214567 Z",
            "m 5.08,5.23875 v 4.7625",
            "m 7.62,5.23875 v 4.7625",
            "m 7.3024999,6.50875 a 0.95249999,0.63499999 0 0 1 -0.9525,0.635 0.95249999,0.63499999 0 0 1 -0.9525,-0.635 0.95249999,0.63499999 0 0 1 0.9525,-0.635 0.95249999,0.63499999 0 0 1 0.9525,0.635 z",
            "m 5.3975,6.50875 v 1.905",
            "m 7.3025,6.50875 v 1.905",
            "m 4.7625,5.23875 v 4.7625",
            "m 7.9375,5.23875 v 4.7625",
            "m 6.3499995,3.3954357 -0.195248,-0.494564 -0.5084,0.155705 0.264931,-0.461006 -0.438718,-0.3004033 0.525611,-0.080302 -0.038671,-0.5303015 0.390495,0.360872 0.390495,-0.360872 -0.03867,0.5303016 0.525611,0.080302 -0.438717,0.3004033 0.26493,0.4610055 -0.5084,-0.155705 z"
        ]
    },
    {
        id: 'dam',
        name: 'Dam',
        level: 2,
        land: 'river',
        requirements: [['bridge', 'quarry']],
        ancestor: 'bridge',
        image: [
            "m 1.27,1.905 0.3175,1.9049999 0.3175,-0.635 0.9525,2.8575 0.3175,-0.635 L 3.81,8.255 h 5.0799999 l 0.3175,-1.5875001 0.3175,0.635 0.6350001,-3.175 0.635,0.635 L 11.43,1.905",
            "M 1.905,3.1749999 C 5.08,3.81 7.62,3.81 11.1125,3.1749999",
            "M 6.3499999,3.8099999 V 8.255",
            "m 4.7625,3.4925 -1e-7,4.7625",
            "m 7.9375,3.4925 -1e-7,4.7625",
            "m 9.2074999,3.4924999 v 3.175",
            "m 3.4925,3.4924999 v 3.175",
            "m 3.81,8.255 c 0.165556,0.173832 -0.18825,0.293624 1.5874999,0.635 0.07147,0.225348 0.635,0.3174999 0.036511,0.616745 -0.614707,0.1746024 -0.3055295,0.75095 -0.036511,0.970755 2.4610218,0.998976 0.3288715,3.08916 2.2225,0.635 0.1620675,-0.56521 -0.5376446,-0.777817 -0.635,-0.9525 -0.5003136,-0.3517991 0.011137,-1.0622099 0.3174996,-1.269996 1.1212296,-0.206242 1.7072939,-0.417388 1.5875,-0.635"
        ]
    },
    {
        id: 'forge',
        name: 'Forge',
        level: 2,
        land: 'plains',
        requirements: [['underground-mine', 'building']],
        ancestor: 'building',
        image: [
            "m 2.54,6.3499999 0.9525,-0.3175 v -0.3175 h 5.7149999 v 0.3175 l 0.9525001,0.3175 -0.9525001,0.3175 v 0.3175 h -0.635 C 7.3341752,7.3882421 7.2074686,6.9611479 7.3025,7.9375 L 7.62,8.255 8.2549999,8.5724999 v 0.635 L 4.445,9.2075 V 8.5725 L 5.08,8.255 5.3975,7.9375 C 5.4735291,7.0093632 5.4368079,7.393047 4.1275,6.985 H 3.4925 V 6.6675 Z",
            "m 5.0799999,5.7149999 -0.635,-0.3175 0.9525,-1.9049999 0.635,0.3175 z",
            "m 5.4787987,4.7070184 2.2225,0.9525"
        ]
    },
    {
        id: 'market',
        name: 'Market',
        level: 2,
        land: 'plains',
        requirements: [['livestock', 'farm']],
        ancestor: 'building',
        image: [
            "M 1.905,9.525 H 5.08 V 5.08 H 1.905 Z",
            "M 1.905,7.3025 H 5.08",
            "M 1.27,5.08 H 5.715 L 5.08,3.175 H 1.905 Z",
            "m 4.1275,7.3024999 v 2.2225",
            "m 2.8575,7.3024999 v 2.2225",
            "m 7.62,9.525 h 3.175 V 5.08 H 7.62 Z",
            "m 7.62,7.3025 h 3.175",
            "M 6.985,5.08 H 11.43 L 10.795,3.175 H 7.62 Z",
            "M 7.6199999,7.9374999 H 10.795",
            "m 8.2549999,7.6199999 v -0.635",
            "m 9.2074999,7.6199999 v -0.3175",
            "m 9.8424999,7.6199999 0.3175001,-0.635 0.3175,0.635 z",
            "m 2.54,5.0799999 v 0.635",
            "m 3.4925,5.0799999 v 0.9525",
            "m 4.1274999,5.0799999 v 0.9525",
            "m 4.7624999,5.0799999 v 0.635",
            "m 8.2549999,5.0799999 v 0.635 H 10.16 v -0.635"
        ]
    },
    {
        id: 'school',
        name: 'School',
        level: 2,
        land: 'plains',
        requirements: [['factory', 'city'], ['factory', 'metropolis']],
        ancestor: 'building',
        image: [
            "M 9.8425,4.445 4.1275001,6.35 2.8575001,3.81 8.5725,1.905 Z",
            "m 2.8575,3.81 c -0.4331,-0.00396 -0.413473,1.0737418 1e-7,1.905",
            "M 9.7065355,6.3953215 9.8424999,6.3499995 9.8425,4.445",
            "M 2.9934201,5.98684 4.1274999,8.2549999 9.7065355,6.3953215",
            "M 2.8575,5.7149999 2.9934201,5.98684",
            "M 4.7625,6.838956 9.2074999,5.2514559",
            "m 4.7625,7.5287225 4.445,-1.5875",
            "m 2.8575,4.7625 1.27,2.54",
            "m 2.8575,6.0325 c -0.4331,-0.00396 -0.4134731,0.4387418 0,1.27",
            "m 2.8575,7.3025 1.27,2.54 5.7149999,-1.905 v -1.27",
            "m 4.1274999,8.5724999 5.715,-1.905",
            "m 4.335467,6.4230223 v 1.5875",
            "m 4.335467,8.645522 v 0.9525",
            "M 4.7625,6.838956 9.2074999,5.2514559",
            "m 4.7625,9.04875 4.445,-1.5875"
        ]
    },
    {
        id: 'paper-mill',
        name: 'Paper mill',
        level: 2,
        land: 'forest',
        requirements: [['forestry', 'factory']],
        ancestor: 'forestry',
        image: [
            "M 6.3499999,8.5725002 A 2.54,2.54 0 0 1 3.8099999,11.1125 2.54,2.54 0 0 1 1.27,8.5725002 2.54,2.54 0 0 1 3.8099999,6.0325003 a 2.54,2.54 0 0 1 2.54,2.5399999 z",
            "m 4.1274999,8.5725002 a 0.3175,0.3175 0 0 1 -0.3175,0.3175 0.3175,0.3175 0 0 1 -0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,0.3175 z",
            "M 11.43,8.5725002 A 2.54,2.54 0 0 1 8.8900003,11.1125 2.54,2.54 0 0 1 6.3500004,8.5725002 2.54,2.54 0 0 1 8.8900003,6.0325003 2.54,2.54 0 0 1 11.43,8.5725002 Z",
            "m 9.2075003,8.5725002 a 0.3175,0.3175 0 0 1 -0.3175,0.3175 0.3175,0.3175 0 0 1 -0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,0.3175 z",
            "m 8.8899999,4.1275001 a 2.54,2.54 0 0 1 -2.54,2.5399999 2.54,2.54 0 0 1 -2.54,-2.5399999 2.54,2.54 0 0 1 2.54,-2.54 2.54,2.54 0 0 1 2.54,2.54 z",
            "m 6.6674999,4.1275001 a 0.3175,0.3175 0 0 1 -0.3175,0.3175 0.3175,0.3175 0 0 1 -0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,0.3175 z"
        ]
    },
    {
        id: 'facility',
        name: 'Facility',
        level: 2,
        land: 'plains',
        requirements: [['building', 'forge']],
        ancestor: 'building',
        image: [
            "m 10.4775,3.8100001 -6.985,3.4925",
            "m 6.0324999,6.6675 v 0.635 l 1.27,-0.635 v -0.635 z",
            "m 4.1275,7.6200001 v 0.635 l 1.27,-0.635 v -0.635 z",
            "m 7.9375,5.7150001 v 0.635 l 0.635,-0.3175 v -0.635 z",
            "M 10.4775,5.715 7.9374999,6.985 V 7.62",
            "M 7.9374999,6.985 9.2075,7.62 l 2.54,-1.27 -1.27,-0.635",
            "M 9.2075,7.62 V 8.255 L 7.9374999,7.62",
            "m 11.7475,6.35 v 0.635 l -2.54,1.27",
            "m 7.9374999,7.62 -4.445,2.2225 L 0.9525,8.5725 v -2.54 l 6.9849999,-3.4924999 2.5400001,1.27 V 5.715",
            "m 0.9525,6.0325 2.5399999,1.27 v 2.54",
            "m 9.8425,6.0325 v -1.27 l 0.635,-0.3175",
            "M 9.8425,4.7625 9.2075,5.08 v 1.27"
        ]
    },
    {
        id: 'wind-turbine',
        name: 'Wind turbine',
        level: 2,
        land: 'hills',
        requirements: [['windmill', 'factory']],
        ancestor: 'windmill',
        image: [
            "m 1.9047652,10.797367 c 2.9355972,-0.8326456 5.8979996,-0.8605918 8.8899998,0",
            "m 6.0324999,5.3974999 h 0.635 M 5.7149999,10.16 6.0324997,5.3974997 c -0.1925566,0 -0.268332,-0.1167813 -0.2981513,-0.2795191 M 5.7149999,4.7697469 v -0.00725 -0.3175 c 0,-0.3175 0,-0.3175 0.3175,-0.3175 h 0.3175 m 0.307675,0 h 0.00983 c 0.3175,0 0.3175,0 0.3175,0.3175 v 0.3175 c 0,0.1249432 0,0.2498863 -0.019349,0.355481 M 6.7985695,5.3736768 c -0.036204,0.015427 -0.079439,0.023823 -0.1310698,0.023823 L 6.9849999,10.16",
            "M 6.35,4.7625001 3.0504432,6.6675 C 3.76763,6.0112405 5.6413239,4.805037 5.916287,4.646287 Z",
            "M 6.3499999,4.7625 6.35,0.9525 C 6.559744,1.9017317 6.6674999,4.1275 6.6674999,4.445 Z",
            "M 6.35,4.7624999 9.6495568,6.6675 C 8.722626,6.3745278 6.7411762,5.354963 6.4662131,5.196213 Z"
        ]
    },
    {
        id: 'hospital',
        name: 'Hospital',
        level: 3,
        land: 'plains',
        requirements: [['medical-lab', 'facility']],
        ancestor: 'facility',
        image: ["m 7.6199999,2.54 h -2.54 V 5.0799999 H 2.54 v 2.54 H 5.0799999 V 10.16 h 2.54 V 7.6199999 H 10.16 v -2.54 H 7.6199999 Z"]
    },
    {
        id: 'factory',
        name: 'Factory',
        level: 3,
        land: 'plains',
        requirements: [['facility', 'forge']],
        ancestor: 'facility',
        image: [
            "M 1.2700001,10.4775 V 5.3974999 l 1.27,1.27 v -1.27 l 1.27,1.27 v -1.27 l 1.2699999,1.27 v -1.27 l 1.27,1.27 v -1.27 l 1.27,1.27 v -1.27 l 1.27,1.27 L 9.2075001,5.715 H 11.1125 L 11.43,6.6674999 V 10.4775 Z",
            "M 9.525,5.7149999 V 2.2225 h 1.27 v 3.4924999",
            "M 8.89,6.6674999 V 10.4775"
        ]
    },
    {
        id: 'data-center',
        name: 'Data center',
        level: 3,
        land: 'plains',
        requirements: [['semi-conductor-factory', 'coal-powerplant'], ['semi-conductor-factory', 'nuclear-powerplant'], ['semi-conductor-factory', 'wind-turbine']],
        ancestor: 'facility',
        image: [
            "m 1.905,4.7625 v 1.27 h 8.89 v -1.27 z",
            "m 1.905,6.6675001 v 1.27 h 8.89 v -1.27 z",
            "M 2.54,5.3974999 H 2.8575",
            "M 3.4925,5.3974999 H 4.4449999",
            "m 5.0799999,5.3974999 h 0.9525",
            "m 9.8424999,5.0799999 v 0.635 H 10.4775 v -0.635 z",
            "M 2.2225,6.985 V 7.62 h 0.635 V 6.985 Z",
            "M 3.175,6.985 V 7.62 H 3.81 V 6.985 Z",
            "m 6.9849999,6.985 h 0.3175",
            "m 6.9849999,7.62 h 0.3175",
            "m 7.6199999,6.985 h 0.3175",
            "m 7.6199999,7.62 h 0.3175",
            "M 9.5249999,7.3025 H 10.16",
            "m 4.4449999,6.9849999 v 0.635",
            "m 5.0799999,6.9849999 v 0.635",
            "m 5.7149999,6.9849999 v 0.635",
            "m 6.9849999,6.0324999 v -1.27 h 0.635 v 1.27 h 0.635 v -1.27 h 0.635 v 1.27",
            "m 8.8899999,6.6674999 v 1.27 h -0.3175 v -1.27 h -2.2225 v 1.27"
        ]
    },
    {
        id: 'metropolis',
        name: 'Metropolis',
        level: 3,
        land: 'plains',
        requirements: [['factory', 'city']],
        ancestor: 'city',
        image: [
            "M 3.8100001,9.2075 5.08,2.8575 h 2.54 l 1.27,6.35 z",
            "M 10.16,9.2075 8.89,5.3974999 h 1.27 L 11.7475,9.2075 H 10.16",
            "M 2.8575001,9.2075 4.1275,4.7624999 H 2.5400001 L 0.3175001,9.2075 Z",
            "m 8.89,5.3974999 -0.635,0.3175",
            "M 10.16,9.2075 8.89,8.8899999",
            "m 2.8575001,9.2075 0.9525,-0.3175001",
            "m 4.1275,4.7624999 0.635,0.3175",
            "m 4.1275,8.2549999 h 4.445",
            "M 5.715,8.2549999 V 9.2075",
            "M 6.985,8.2549999 V 9.2075",
            "m 6.35,3.4924999 v 4.1275",
            "m 5.715,3.4924999 -0.3175,4.1275",
            "m 6.985,3.4924999 0.3175,4.1275",
            "m 0.3175,9.8424999 h 12.065"
        ]
    },
    {
        id: 'shopping-mall',
        name: 'Shopping mall',
        level: 3,
        land: 'plains',
        requirements: [['market', 'facility']],
        ancestor: 'market',
        image: [
            "m 2.5400002,8.8899998 0.635,-4.4449999 h 3.81 l 0.6349999,4.4449999 z",
            "M 6.0325,4.445 A 0.95249999,-1.2700001 0 0 0 5.086417,3.1750287 0.95249999,-1.2700001 0 0 0 4.1275865,4.4278883 L 5.08,4.4450003 Z",
            "m 4.4450001,5.2090843 a 0.3175,0.3175 0 0 1 -0.3175,0.3175 0.3175,0.3175 0 0 1 -0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,0.3175 z",
            "m 6.3499999,5.2090843 a 0.3175,0.3175 0 0 1 -0.3175,0.3175 0.3175,0.3175 0 0 1 -0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,0.3175 z",
            "M 7.0250635,4.72367 9.3977809,4.3052961 10.795,8.5724997 7.6540627,9.1263316",
            "M 7.0236575,4.7147205 7.5217221,4.6360959 8.4597515,4.4706961 v 0 A 1.2700001,0.95249996 80 0 0 7.3075136,3.384304 1.2700001,0.95249996 80 0 0 6.8674657,3.6294203",
            "M 6.8674657,3.6294203 A 1.2700001,0.95249996 80 0 0 6.5594613,4.444764",
            "M 8.9051094,5.1680391 A 0.3175,0.3175 0 0 1 8.6475662,5.5358488 0.3175,0.3175 0 0 1 8.2797564,5.2783057 0.3175,0.3175 0 0 1 8.5372996,4.9104959 0.3175,0.3175 0 0 1 8.9051094,5.1680391 Z"
        ]
    },
    {
        id: 'mechanized-farm',
        name: 'Mechanized farm',
        level: 3,
        land: 'plains',
        requirements: [['factory', 'farm']],
        ancestor: 'farm',
        image: [
            "m 6.0325,7.7787499 a 1.905,1.905 0 0 1 -1.9049999,1.905 1.905,1.905 0 0 1 -1.905,-1.905 1.905,1.905 0 0 1 1.905,-1.9049999 A 1.905,1.905 0 0 1 6.0325,7.7787499 Z",
            "m 9.8425003,8.7312498 a 0.95249999,0.95249999 0 0 1 -0.9525,0.9525 0.95249999,0.95249999 0 0 1 -0.9524999,-0.9525 0.95249999,0.95249999 0 0 1 0.9524999,-0.9525 0.95249999,0.95249999 0 0 1 0.9525,0.9525 z",
            "m 5.7149999,9.04875 h 2.2225",
            "M 4.1275,3.0162501 V 5.87375",
            "m 7.9374999,5.55625 v -1.27 h 0.635 v 1.27",
            "M 2.54,6.5087501 C 3.4655444,5.4149335 4.4411635,5.9598656 5.3974999,5.87375",
            "m 9.2075003,8.7312498 a 0.3175,0.3175 0 0 1 -0.3175,0.3175 0.3175,0.3175 0 0 1 -0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,-0.3175 0.3175,0.3175 0 0 1 0.3175,0.3175 z",
            "m 6.0324999,7.77875 h 3.81 v 0.9525 L 10.16,5.55625 H 5.7149999 l -0.635,0.635 0.635,-0.635 h 0.3175 l 0.3175,-2.5399999 H 4.1275 V 5.87375 3.0162501 H 2.54 V 6.50875",
            "m 4.7625,7.7787499 a 0.63499999,0.63499999 0 0 1 -0.6349999,0.635 0.63499999,0.63499999 0 0 1 -0.635,-0.635 0.63499999,0.63499999 0 0 1 0.635,-0.6349999 A 0.63499999,0.63499999 0 0 1 4.7625,7.7787499 Z"
        ]
    },
    {
        id: 'steamship',
        name: 'Steamship',
        level: 3,
        land: 'water',
        requirements: [['factory', 'port']],
        ancestor: 'ships',
        image: [
            "m 1.905,6.985 0.3175,1.5875 c 1.4368969,-0.3391264 2.8221948,-0.5008295 4.014812,0 1.6044982,0.4278088 3.1219396,0.4188387 4.557688,0 L 11.1125,6.985 H 9.5249999 l -0.635,-0.9525 h -0.9525 l -0.3175,-0.635 H 2.8575 v 0.635 h -0.635 z",
            "M 3.81,5.3975 V 4.445 l 0.9525,10e-8 v 0.9525",
            "M 5.3974999,5.3975 V 4.445 h 0.9525 v 0.9525",
            "M 9.5249999,6.985 H 1.905",
            "M 7.9374999,6.0325 H 2.8575"
        ]
    },
    {
        id: 'armada',
        name: 'Armada',
        level: 3,
        land: 'water',
        requirements: [['soldiers', 'port']],
        ancestor: 'ships',
        image: [
            "M 1.27,5.715 1.5875,7.62 c 0.9525,-0.3175 1.4101619,0 2.1331482,0 1.6768518,0.3175 1.5785572,0 2.3118518,0 0.9525,0 0.884582,-0.536927 1.27,-1.27 L 7.62,6.0325 C 5.79068,6.4946937 6.35,6.35 2.9522394,6.4095134 2.5986951,6.4157059 2.3353411,5.8637904 1.9799428,5.7930804 1.5875,5.715 1.5429836,5.715 1.27,5.715 Z",
            "M 5.715,6.35 V 4.1275 2.54 c 0.9525,0.3175 0.635,1.27 0,2.2225 0.635,0.3175 0.9525,0.635 0,1.5875",
            "M 3.81,6.35 V 2.54 c 0.1884767,0.3626163 0.635,0.9525 0.635,1.5875 10e-8,0.3175001 -0.4977264,0.9515616 -0.635,1.27",
            "M 1.5874999,7.62 C 1.27,7.62 0.635,7.9375 0.635,7.62",
            "m 6.3499999,7.62 c 0.6350001,0 0.9525001,-0.3175 0.9525,0",
            "m 3.4924999,5.3974999 h 0.635 l -0.3175,0.3175 z",
            "m 3.1749999,6.3499999 -1.27,-1.905 v 1.27",
            "m 5.7149999,4.7624999 -0.9525,1.5875",
            "m 3.8099999,5.3974999 -0.635,0.9525",
            "M 3.8099999,2.5399999 3.81,2.2225 h 0.3175 l 0,0.3175 -0.3175001,-10e-8",
            "m 5.3975,9.2075 0.3175,1.905 c 0.9525,-0.3175 1.4101619,0 2.1331482,0 1.6768518,0.3175 1.5785572,0 2.3118518,0 0.9525,0 0.884582,-0.536927 1.27,-1.27 L 11.7475,9.525 C 9.91818,9.9871937 10.4775,9.8425 7.0797394,9.9020134 6.7261951,9.9082059 6.4628411,9.3562904 6.1074428,9.2855804 5.715,9.2075 5.6704836,9.2075 5.3975,9.2075 Z",
            "M 9.8425,9.8425 V 7.62 6.0325 c 0.9525,0.3175 0.635,1.27 0,2.2225 0.635,0.3175 0.9525,0.635 0,1.5875",
            "m 7.9375,9.8425 v -3.81 c 0.1884767,0.3626163 0.635,0.9525 0.635,1.5875 10e-8,0.3175001 -0.4977264,0.9515616 -0.635,1.27",
            "M 5.7149999,11.1125 C 5.3975,11.1125 4.7625,11.43 4.7625,11.1125",
            "m 10.4775,11.1125 c 0.635,0 0.9525,-0.3175 0.9525,0",
            "m 7.6199999,8.8899999 h 0.635 l -0.3175,0.3175 z",
            "m 7.3024999,9.8424999 -1.27,-1.905 v 1.27",
            "m 9.8424999,8.2549999 -0.9525,1.5875",
            "m 7.9374999,8.8899999 -0.635,0.9525",
            "M 7.9374999,6.0324999 7.9375,5.715 h 0.635 l -10e-8,0.3174999 h -0.635"
        ]
    },
    {
        id: 'lighthouse',
        name: 'Lighthouse',
        level: 3,
        land: 'coast',
        requirements: [['port', 'glass-furnace']],
        ancestor: 'port',
        image: [
            "m 2.54,10.16 0.635,-3.1750001 0.9524999,0.3175 0.3175,-0.635 3.4925,-0.3175 0.635,0.9525 0.9525,2.54 0.9525001,-0.635 L 10.795,10.16",
            "M 5.0799999,6.6674999 5.3974999,2.54 V 1.27 h 1.5875 v 1.27 h -1.5875 1.5875 l 0.3175,3.8099999",
            "M 10.16,1.5875 7.9375,1.905 10.16,2.2225",
            "M 2.2225001,1.5875 4.445,1.905 2.2225001,2.2225"
        ]
    },
    {
        id: 'university',
        name: 'University',
        level: 3,
        land: 'plains',
        requirements: [['glass-furnace', 'school']],
        ancestor: 'school',
        image: [
            "M 1.5875001,3.81 5.3975,6.35 9.2075001,3.81 5.3975,1.2700001 Z",
            "M 5.3975,3.81 2.2225001,4.1275 V 8.255",
            "m 2.5400001,4.445 v 1.27 c 1.9751,1.666854 3.8721551,1.721789 5.7149999,0 v -1.27",
            "m 12.065,10.16 0,-3.175 L 10.4775,5.715 8.89,6.9850001 V 8.5725 H 7.9375 l -1.27,-0.9524999 -0.635,0.635 L 5.715,8.5725 4.7625,7.62 3.81,8.5725 H 1.27 V 10.16",
            "M 8.8899999,8.5724999 V 10.16",
            "m 11.429999,7.6199999 a 0.95249999,0.95249999 0 0 1 -0.9525,0.9525 0.95249999,0.95249999 0 0 1 -0.9525,-0.9525 0.95249999,0.95249999 0 0 1 0.9525,-0.9525 0.95249999,0.95249999 0 0 1 0.9525,0.9525 z",
            "m 10.4775,6.6674999 v 0.9525 l 0.635,0.635"
        ]
    },
    {
        id: 'swedish-furniture-store',
        name: 'Swedish furniture store',
        level: 3,
        land: 'forest',
        requirements: [['sawmill', 'factory', 'market'], ['sawmill', 'factory', 'shopping-mall']],
        ancestor: 'sawmill',
        image: [
            "M 9.0706566,11.677927 8.8666235,11.592133 8.8675457,10.720624 8.8684678,9.8491157 9.4656179,9.536619 C 9.7940509,9.3647503 10.048124,9.2084273 10.030226,9.1892396 10.012322,9.1700519 9.3950169,8.9127635 8.6584321,8.6174875 L 7.3191869,8.0806216 V 7.3242144 6.5678072 l 0.1679582,-0.059067 c 0.1406575,-0.049466 0.4281169,0.040002 1.7684989,0.550429 0.880298,0.3352227 1.970031,0.7493427 2.42163,0.9202661 l 0.821088,0.3107696 V 9.0663526 9.8425 l -1.452695,0.875065 C 9.1330649,11.869667 9.3155893,11.780913 9.0706566,11.677927 Z M 9.2317414,10.81309 c -0.015548,-0.677655 -0.03136,-0.775561 -0.1282648,-0.79414 -0.1003,-0.019231 -0.1105313,0.04891 -0.1105313,0.736106 0,0.737838 0.017299,0.806793 0.2072164,0.825997 0.027123,0.0027 0.041334,-0.34284 0.03158,-0.767963 z M 10.97199,10.607324 12.34046,9.7865115 V 9.1388387 c 0,-0.3562202 -0.02131,-0.6470151 -0.04737,-0.6462111 -0.02606,8.022e-4 -0.701085,0.3489773 -1.500067,0.7737185 l -1.4526914,0.7722559 -0.017758,0.776768 -0.017758,0.776767 0.1493527,-0.08199 c 0.082145,-0.0451 0.7651667,-0.451367 1.5178257,-0.902814 z M 10.080685,9.5328784 C 10.50721,9.3068377 11.161724,8.9598545 11.535162,8.7618045 11.9086,8.5637548 12.21414,8.3830685 12.21414,8.36028 12.21414,8.337492 12.093338,8.273771 11.945707,8.2186807 11.798069,8.1635895 10.770768,7.7760274 9.6628163,7.3574306 8.5548649,6.9388338 7.6240344,6.5963458 7.5943041,6.5963458 c -0.1756638,0 0.011,0.1184559 0.4361251,0.2767637 1.7943646,0.6681831 3.7761178,1.4378414 3.8230398,1.4847636 0.03207,0.032074 -0.488313,0.338008 -1.228753,0.7223814 -0.7064128,0.3667104 -1.341232,0.7101358 -1.4107087,0.763169 -0.1109754,0.084708 -0.1131101,0.096665 -0.017572,0.098433 0.059813,0.00112 0.4577249,-0.1829341 0.8842497,-0.4089748 z m 0.89681,-0.7890696 C 11.343914,8.5527477 11.64391,8.3822139 11.644154,8.3648447 11.644408,8.3474755 11.211406,8.1719418 10.681946,7.9747707 10.152487,7.7775988 9.2005856,7.4177806 8.5666103,7.1751747 L 7.4139279,6.7340732 V 7.3533113 7.9725486 L 8.819253,8.5416523 c 0.7729289,0.3130072 1.424833,0.5647023 1.448676,0.5593219 0.02384,-0.00538 0.343148,-0.1661043 0.709566,-0.3571654 z M 1.9821095,10.84116 c 0,-0.09704 0.056844,-0.728201 0.126321,-1.4025836 C 2.2506012,8.0585824 2.2570592,7.92272 2.1804837,7.92272 2.150637,7.92272 1.992239,8.040651 1.8284899,8.1847882 L 1.5307647,8.446857 1.3961509,8.3122431 1.2615371,8.1776289 1.4330757,7.9985816 C 1.5711971,7.8544136 1.5970289,7.7816058 1.5656762,7.6248422 1.5330307,7.4616147 1.5492855,7.4229952 1.6662589,7.3858694 1.787293,7.3474544 1.7427784,7.3056787 1.3303111,7.0705921 0.64351212,6.6791493 0.42691231,6.4959518 0.27162086,6.1751624 0.15183092,5.9277091 0.14320777,5.8590124 0.2057382,5.6503046 0.33848491,5.2072351 1.0647198,4.7213201 2.2058102,4.3120804 2.6753339,4.1436906 2.6798607,4.1306283 2.4867221,3.5014724 2.3144611,2.9403252 2.2677343,2.4894994 2.3545646,2.2264009 2.4469861,1.9463612 2.7681262,1.6429106 3.0760996,1.5446104 3.5518124,1.3927707 4.3018845,1.7276764 4.6869301,2.2638431 4.9453483,2.6236839 4.9429918,2.72741 4.6752608,2.7776372 l -0.2122429,0.039816 -0.072061,0.515701 c -0.096556,0.6910038 -0.093797,0.7213756 0.070212,0.7728694 0.1915704,0.060147 0.7856902,0.4413576 1.0570476,0.6782432 1.0577998,0.9234223 1.3294407,2.0668889 0.6039354,2.5422583 -0.1304205,0.085454 -0.1609171,0.15601 -0.1609171,0.372286 0,0.2558716 -0.010527,0.2703228 -0.2558089,0.3512739 -0.140695,0.046434 -0.2652603,0.1007226 -0.2768118,0.1206409 -0.011558,0.019918 -0.039168,0.3346506 -0.06137,0.6994035 -0.022201,0.3647522 -0.057045,0.7938534 -0.07743,0.9535575 -0.036519,0.2860931 -0.031399,0.2964311 0.34741,0.7013791 0.2114615,0.226053 0.3661331,0.429348 0.3437148,0.451766 -0.022418,0.02242 -0.9313265,0.04076 -2.0197957,0.04076 H 1.9821095 Z M 3.8769299,9.7265274 c 0,-0.6907114 0.025134,-1.180279 0.061757,-1.2029131 0.039174,-0.024211 0.068044,0.3959132 0.078951,1.1489544 l 0.017194,1.1871223 0.8368792,0.01763 c 0.4602835,0.0097 0.8368789,-0.0067 0.8368789,-0.03636 0,-0.0297 -0.073834,-0.122888 -0.1640768,-0.207106 C 5.1251207,10.242465 5.1208916,10.224727 5.2058013,9.2132509 5.2481094,8.7092557 5.26729,8.2814603 5.2484243,8.2625942 5.2295586,8.2437285 5.1513803,8.2618678 5.0746963,8.3029111 4.9643908,8.3619411 4.8178868,8.3547264 4.3732524,8.2683629 4.0641428,8.2083231 3.7996557,8.1404639 3.7855035,8.117565 3.7468337,8.0549961 3.6154704,6.0788234 3.6478299,6.0464638 3.6632354,6.0310583 3.9434568,6.1013165 4.2705432,6.2025951 L 4.8652458,6.3867363 5.3905872,6.1441575 C 5.6795248,6.0107389 5.9261219,5.9015782 5.9385803,5.9015782 c 0.012463,0 0.022652,0.08359 0.022652,0.1857544 0,0.1021649 0.028422,0.2033204 0.063161,0.22479 0.1044082,0.064528 0.072995,0.1248573 -0.1263209,0.2425958 -0.1583521,0.093541 -0.1894822,0.096643 -0.1894822,0.018881 0,-0.051176 0.030915,-0.1033542 0.068702,-0.1159495 0.037786,-0.012588 0.059102,-0.097197 0.04737,-0.1880047 L 5.8033305,6.1045418 5.376996,6.2957128 4.9506614,6.4868844 v 0.8442391 c 0,0.4810033 0.025384,0.8442392 0.058999,0.8442392 0.032449,0 0.2314047,-0.074771 0.4421247,-0.1661574 C 5.7517073,7.8791329 5.834912,7.8132922 5.834912,7.706034 5.834912,7.630676 5.8032233,7.5373318 5.7644933,7.4986023 5.7127097,7.4468187 5.7441472,7.4022915 5.8832905,7.3303372 6.6947386,6.9107211 6.55332,5.9815479 5.5290722,5.0029877 5.0975792,4.5907417 4.6689599,4.3151558 4.2370871,4.1722906 4.1458088,4.1420954 4.1314371,4.0926293 4.1638084,3.9200747 4.2123844,3.6611427 4.1091511,3.5695371 3.9406369,3.7220403 c -0.082955,0.075073 -0.1612034,0.09189 -0.264453,0.056834 -0.1638265,-0.055623 -0.1557355,-0.05571 -0.35191,0.0038 -0.2185569,0.066302 -0.1690655,-0.069968 0.053602,-0.1475911 0.1282803,-0.044718 0.2349159,-0.047247 0.3094899,-0.00734 0.084538,0.045243 0.1234537,0.035672 0.1514338,-0.037245 0.024455,-0.06373 0.098461,-0.091004 0.2110875,-0.077794 0.1680039,0.01971 0.1754234,0.00752 0.2371401,-0.3893441 0.051969,-0.3341809 0.086982,-0.413435 0.1899804,-0.430029 C 4.8246315,2.6373256 4.8162352,2.5702073 4.4092176,2.151436 4.1005962,1.8339022 3.7376699,1.6729316 3.3264717,1.6712 3.0482658,1.6700284 2.9629792,1.6997501 2.7776721,1.8624521 2.3777776,2.213564 2.3519747,2.6434934 2.669894,3.6582584 2.7350014,3.8660748 2.7687716,4.0888195 2.7449381,4.1532466 2.7165461,4.2299995 2.4765333,4.3553137 2.0488044,4.5167095 0.46185922,5.115515 -0.04119097,5.7245724 0.53820152,6.3456416 0.73066448,6.5519483 1.1680951,6.8508821 1.5873554,7.0626182 1.9477168,7.2446093 1.9952492,7.3513654 1.779654,7.4945154 L 1.6403593,7.5870037 1.8107744,7.6986642 C 2.1658387,7.9313109 2.4862833,7.6253857 2.2921657,7.2390857 2.245448,7.1461169 2.1958451,7.0457521 2.1819353,7.0160527 c -0.013911,-0.029699 0.030149,-0.036404 0.097908,-0.014898 0.078899,0.025041 0.1620344,-0.00382 0.2312079,-0.08025 C 2.6139527,6.8071991 2.6099732,6.7939062 2.4269072,6.6398667 2.1853252,6.4365888 2.186469,6.406863 2.4358772,6.406863 c 0.2606169,0 0.6742402,0.2021078 0.9036296,0.4415386 L 3.5207846,7.0376196 3.3717114,7.1963008 3.2226382,7.3549819 3.0858286,7.2264562 2.9490192,7.0979306 2.6887671,7.3802707 C 2.5456284,7.5355576 2.4150351,7.7282413 2.39856,7.8084553 2.3820848,7.8886701 2.3236213,8.480113 2.2686411,9.1227729 2.213661,9.7654331 2.1524546,10.426251 2.1326272,10.591259 l -0.036049,0.300013 H 2.9867541 3.8769305 Z M 5.7085896,7.0436736 c 0,-0.064875 0.2468647,-0.2578459 0.3298573,-0.2578459 0.1168908,0 0.033667,0.1310625 -0.1403752,0.2210624 -0.1042148,0.053892 -0.1894821,0.070445 -0.1894821,0.036784 z M 3.4979657,2.7751245 c 0,-0.052108 0.042633,-0.094742 0.094742,-0.094742 0.052108,0 0.094741,0.042633 0.094741,0.094742 0,0.052108 -0.042633,0.094742 -0.094741,0.094742 -0.052108,0 -0.094742,-0.042633 -0.094742,-0.094742 z m 0.5368658,-0.094742 c -0.02521,-0.040792 -0.017415,-0.1025896 0.017322,-0.1373275 0.042107,-0.042107 0.07844,-0.038437 0.108998,0.011001 0.02521,0.040792 0.017416,0.1025896 -0.017323,0.1373288 -0.042107,0.042107 -0.07844,0.038437 -0.1089994,-0.011001 z M 1.9189489,7.9109028 c 0,-0.106309 -0.2358886,-0.045739 -0.3675122,0.094368 -0.1058746,0.1126979 -0.11985,0.1627505 -0.061685,0.2209164 0.058166,0.058166 0.1153061,0.036784 0.2522004,-0.094368 C 1.8393001,8.0385532 1.918948,7.9391419 1.9189489,7.9109028 Z M 4.8018441,6.5656635 c -0.027984,-0.072925 -0.9674927,-0.3899174 -1.01496,-0.3424502 -0.015283,0.015282 0.00318,0.4318951 0.041031,0.925804 l 0.06882,0.8980154 0.22695,0.039725 c 0.1248225,0.021848 0.3264281,0.059143 0.4480124,0.082874 l 0.2210624,0.04315 0.017771,-0.7890878 c 0.00977,-0.4339986 0.00586,-0.8201123 -0.00869,-0.8580302 z M 2.7311317,7.2058519 C 2.8555561,7.073408 2.8600136,7.0486715 2.772537,6.9760728 2.691487,6.9088068 2.6540197,6.9132558 2.5562221,7.0017618 c -0.070056,0.0634 -0.1051993,0.1570896 -0.08619,0.2297799 0.041753,0.1596671 0.091571,0.1547658 0.2610996,-0.02569 z M 3.3399934,6.9751954 C 3.2609949,6.8473727 2.7227162,6.5330972 2.5855605,6.5347173 c -0.1008852,0.00119 -0.045449,0.077421 0.2492182,0.3426952 0.3172391,0.2855944 0.3930406,0.3274819 0.4653884,0.2571714 0.047534,-0.046195 0.065455,-0.1179199 0.039826,-0.1593885 z m 3.127965,2.5515549 C 5.5868613,9.1341715 5.3378893,8.9964511 5.509279,8.9964511 c 0.043227,0 0.4739856,0.1705347 0.9572387,0.3789644 0.4832532,0.2084307 0.8914543,0.3789644 0.9071131,0.3789644 0.015659,0 0.014723,-0.052574 -0.00207,-0.11683 C 7.3517044,9.5616473 7.1601685,9.4468226 6.82481,9.3097798 5.9559779,8.9547373 5.499393,8.7424729 5.5327561,8.7091102 5.5502604,8.6916059 5.9782106,8.8514226 6.4837575,9.0642578 L 7.4029335,9.4512317 7.9125676,9.2080514 C 8.1928665,9.0743022 8.4224346,8.9506604 8.4227189,8.9332912 8.4230347,8.9159216 7.8977083,8.6929536 7.2553965,8.4378068 6.6130814,8.1826597 6.0875537,7.9462605 6.0875537,7.9124754 c 0,-0.080362 0.06862,-0.056892 1.4155507,0.4841852 l 1.1424568,0.4589369 v 0.2109248 c 0,0.2010754 -0.028019,0.2263952 -0.6000265,0.5422201 C 7.7155201,9.7909541 7.4312971,9.938715 7.4139279,9.9370986 7.3965587,9.9354731 6.9708721,9.7508262 6.4679584,9.5267503 Z M 8.5400525,9.0914733 C 8.5552172,9.0192819 8.4138123,9.0653235 8.0189768,9.2611395 7.6405819,9.4488047 7.4770885,9.5639879 7.4770885,9.6429078 c 0,0.094877 0.083655,0.06764 0.5210757,-0.1696661 C 8.2847557,9.3177639 8.5286052,9.1459684 8.5400525,9.0914733 Z M 9.0045817,5.4557932 C 8.6678537,5.3886771 8.3670313,5.2071665 8.112977,4.9178147 7.836171,4.6025499 7.7297313,4.3029401 7.7297313,3.839043 c 0,-0.9329559 0.6834358,-1.5980099 1.6421776,-1.5980099 0.9511511,0 1.6420651,0.6772859 1.6401731,1.6078231 -0.0021,1.0576263 -0.951367,1.8174435 -2.0075003,1.606937 z M 10.050718,5.1958613 C 11.201251,4.6534249 11.137951,2.9543325 9.9485205,2.4527134 9.4329538,2.2352834 8.6579886,2.3937807 8.282439,2.7934638 7.8771048,3.2248452 7.7336056,3.9072395 7.9428923,4.4081342 8.2888727,5.2361803 9.2239735,5.5856421 10.050718,5.1958613 Z M 9.2894117,4.5979747 c -0.050461,-0.050461 0.00658,-0.1490922 0.086224,-0.1490922 0.032688,0 0.059432,0.042633 0.059432,0.094742 0,0.097673 -0.074528,0.1254812 -0.145656,0.05435 z M 9.2804434,4.20154 C 9.2176163,4.0998834 9.357591,3.835753 9.4930656,3.8003257 9.665502,3.7552325 9.7214111,3.5940918 9.6324007,3.3987357 9.5281792,3.1699939 9.1866878,3.207113 9.0659125,3.4603115 9.0019591,3.5943864 8.9618603,3.6219734 8.9084965,3.5686099 8.8044008,3.4645137 8.9853574,3.1709052 9.2001707,3.0953595 9.74539,2.9036161 10.115598,3.6517156 9.61609,3.93583 9.5169685,3.9922096 9.4356886,4.0880771 9.4354688,4.1488694 9.4350267,4.2661983 9.3402992,4.2983886 9.2804434,4.20154 Z M 6.7856522,2.5896561 C 6.6754008,2.4568117 6.7511501,2.1979826 6.9126386,2.1557523 7.1052067,2.1053951 7.3003024,2.318916 7.2319367,2.5052059 7.1683938,2.6783544 6.9012236,2.728911 6.7856522,2.5896561 Z M 7.0981245,2.4277409 c 0,-0.084214 -0.042107,-0.126321 -0.1263209,-0.126321 -0.1217229,0 -0.1711591,0.1235902 -0.084214,0.2105355 0.086945,0.086945 0.2105354,0.037509 0.2105349,-0.084215 z M 5.5187248,2.3325388 C 5.448837,2.2483291 5.4515609,2.215576 5.5354258,2.131711 5.6708738,1.9962634 5.8494562,2.0715148 5.8235509,2.2531214 5.7988734,2.4261162 5.6323857,2.4694918 5.5187248,2.3325388 Z m 0.1898648,-0.094281 c 0,-0.034737 -0.012532,-0.063161 -0.027854,-0.063161 -0.015319,0 -0.045419,0.028423 -0.066888,0.063161 -0.02147,0.034737 -0.00894,0.063161 0.027853,0.063161 0.036789,0 0.066888,-0.028422 0.066889,-0.063161 z"
        ]
    },
    {
        id: 'semi-conductor-factory',
        name: 'Semi conductor factory',
        level: 3,
        land: 'plains',
        requirements: [['advanced-mine', 'glass-furnace']],
        ancestor: 'facility',
        image: [
            "M 3.81,3.81 V 8.8899999 H 8.8899999 V 3.81 Z",
            "M 4.4449999,2.8575 V 3.81 h 1.27 V 2.8575 3.81 h 1.27 V 2.8575 3.81 h 1.27 V 2.8575",
            "m 9.8424999,4.4449999 h -0.9525 v 1.27 h 0.9525 -0.9525 v 1.27 h 0.9525 -0.9525 v 1.27 h 0.9525",
            "m 8.2549999,9.8424999 v -0.9525 h -1.27 v 0.9525 -0.9525 h -1.27 v 0.9525 -0.9525 h -1.27 v 0.9525",
            "M 2.8575,8.2549999 H 3.81 v -1.27 H 2.8575 3.81 v -1.27 H 2.8575 3.81 v -1.27 H 2.8575"
        ]
    },
    {
        id: 'spaceport',
        name: 'Spaceport',
        level: 3,
        land: 'mountain',
        requirements: [['observatory', 'semi-conductor-factory', 'university']],
        ancestor: 'observatory',
        image: [
            "m 3.4925,10.16 h 5.715",
            "M 7.62,6.6675 V 4.445 L 7.1382009,3.175 6.6675,4.445 V 6.6675 L 6.35,7.62 v 2.54 H 7.9375 V 7.62 Z",
            "m 6.0324999,4.7625 h -1.27 V 10.16 h 1.27 z",
            "m 6.0324999,4.7625 -1.27,1.2699999 1.27,1.27 -1.27,1.27 1.27,1.27",
            "m 4.7624999,9.8424999 1.27,-1.27 -1.27,-1.27 1.27,-1.27 -1.27,-1.2699999",
            "m 6.0324999,6.0324999 h 0.635",
            "M 6.6675,4.445 H 7.62",
            "M 6.6675,6.6675 H 7.62"
        ]
    },
    {
        id: 'zoo',
        name: 'Zoo',
        level: 3,
        land: 'plains',
        requirements: [['city', 'national-park'], ['metropolis', 'national-park']],
        ancestor: 'facility',
        image: [
            "M 2.54,9.2075 V 6.6675001 h 0.3175 v -0.635 H 2.54 V 5.3975 h 1.27 v 3.81 z",
            "m 8.8899999,9.2075 v -3.81 H 10.16 V 6.0325001 H 9.8425 v 0.635 H 10.16 V 9.2075 Z",
            "m 3.81,6.6675 h 5.0799999 v 2.54 H 3.81 Z",
            "m 5.3974999,6.6675 a 0.95249999,0.95249999 0 0 1 0.9525,-0.9525 0.95249999,0.95249999 0 0 1 0.9525,0.9525",
            "m 4.4449999,6.6675 v 2.54 h 0.635 v -2.54 h 1.27 v 2.54 h 1.27 v -2.54 h 0.635 v 2.54",
            "m 5.715,6.3500001 -1e-7,2.8574999",
            "m 6.985,6.3500001 -1e-7,2.8574999",
            "M 6.35,5.7150001 6.3499999,6.6675",
            "M 3.8100001,5.3975002 C 4.4450001,5.0800003 5.3975,4.7625001 6.35,4.7625001 c 0.9525,0 1.905,0.3175 2.5399999,0.6349999 l 0.6350001,1e-7 c -0.3174999,-0.9524999 -2.8575,-1.27 -3.175,-1.905 -0.3175,0.635 -2.8575,0.9525001 -3.175,1.905 z",
            "M 2.54,6.6675 H 1.27",
            "M 1.27,9.2075 H 11.43",
            "m 10.16,6.6675 h 1.27"
        ]
    },
    {
        id: 'nuclear-powerplant',
        name: 'Nuclear powerplant',
        level: 3,
        land: 'plains',
        requirements: [['factory', 'uranium-mine']],
        ancestor: 'facility',
        image: [
            "m 7.1553061,8.3218492 c 0,0 0,0 0,0",
            "M 10.882031,7.5289938 C 10.595776,6.4837921 10.41341,5.2944117 10.727181,4.3530992 H 7.5521811 c 0.3137708,0.9413125 0.131405,2.1306929 -0.15485,3.1758946",
            "m 11.124056,8.3218492 c 0,0 0,0 0,0",
            "m 8.2444631,4.3530182 c 0.025305,-0.1361946 0.058799,-0.2687879 0.101468,-0.396794 H 5.1709312 c 0.3542675,1.0628025 0.076066,2.441839 -0.2700347,3.5725414",
            "M 11.520931,9.1155993 V 7.5280992 H 3.9803061 v -1.5875 H 1.2021812 v 3.1750001 z",
            "m 2.7896812,5.9405992 v -0.79375 h 2.5451679",
            "m 3.1865561,5.1468492 0.396875,-1.5874999 0.396875,1.5874999",
            "m 3.7818686,3.9562243 c -0.9166969,0.519711 -1.8423996,0.5385534 -2.7781249,0",
            "m 2.823689,6.719847 a 0.46434375,0.46434375 0 0 1 0.2323695,0.4022476 m 0,-0.8042671 L 2.8238637,6.720001 M 3.0560585,7.1220946 H 3.5204022 M 3.0559596,6.3177706 a 0.92868745,0.92868745 0 0 1 0.4644426,0.804324",
            "M 2.127371,7.1220946 A 0.46434375,0.46434375 0 0 1 2.3597329,6.7198513 M 2.127371,6.3178275 2.359629,6.7201101 M 1.6630274,7.1220946 H 2.127371 m -0.4643436,0 A 0.92868745,0.92868745 0 0 1 2.127371,6.3178275",
            "M 2.823689,7.5243421 A 0.46434375,0.46434375 0 0 1 2.5917147,7.5864383 0.46434375,0.46434375 0 0 1 2.3597381,7.5243407 M 2.3595705,7.5241858 2.127371,7.9263615 M 2.8238637,7.524188 3.0560585,7.9263615 m 9.21e-5,-5.32e-5 A 0.92868745,0.92868745 0 0 1 2.5917149,8.050782 0.92868745,0.92868745 0 0 1 2.127371,7.9263615",
            "M 2.5917149,6.9673133 A 0.15478125,0.15478125 0 0 1 2.7464961,7.1220946 0.15478125,0.15478125 0 0 1 2.5917149,7.2768758 0.15478125,0.15478125 0 0 1 2.4369336,7.1220946 0.15478125,0.15478125 0 0 1 2.5917149,6.9673133 Z"
        ] 
    },
    {
        id: 'coal-powerplant',
        name: 'Coal powerplant',
        level: 3,
        land: 'plains',
        requirements: [['factory', 'coal-mine']],
        ancestor: 'facility',
        image: [
            "m 7.1553061,9.591849 c 0,0 0,0 0,0",
            "M 11.235322,8.9087989 C 11.008273,7.8577048 10.863626,6.6616192 11.1125,5.715 H 8.5941823 C 8.8430561,6.6616192 8.6984089,7.8577048 8.4713598,8.9087989",
            "m 11.124056,9.591849 c 0,0 0,0 0,0",
            "M 3.1865561,6.416849 3.5834311,4.8293491 3.9803061,6.416849",
            "m 3.7818686,5.2262241 c -0.9166969,0.519711 -1.8423996,0.5385534 -2.7781249,0",
            "M 1.27,7.3024997 V 10.4775 H 11.43 V 8.8899997 H 6.6674999 v -1.5875 z",
            "m 1.5875,7.3024997 v -0.9525 h 3.1749999 v 0.9525",
            "M 5.3974999,7.3024997 V 3.4924998 h 0.9525 v 3.8099999",
            "m 5.7149999,3.1749998 c 0.036048,-0.013474 0.026753,-0.00363 -0.019299,-0.0612 -0.057995,-0.072493 -0.093547,-0.1164372 -0.073022,-0.2190654 0.00641,-0.032063 0.043702,-0.094873 0.073022,-0.1095327 0.02854,-0.01427 0.07911,-0.0213 0.1095328,-0.036511 C 5.9157464,2.693435 6.0368981,2.5579094 6.0608101,2.4383486 6.068192,2.4014406 6.0529863,2.3835858 6.0425538,2.3470714 5.9542642,2.0380571 6.0720345,2.4579629 6.0242976,2.2192832 5.9979583,2.0875828 5.7811357,1.9746576 5.8234878,1.762897 c 0.00377,-0.018869 0.00323,-0.042745 0.018256,-0.054766 0.019592,-0.015673 0.050581,-0.00703 0.073022,-0.018255 0.070192,-0.035097 0.1366359,-0.1032615 0.2008103,-0.1460445 0.029143,-0.019429 0.250684,-0.1062685 -0.083076,0.043668",
            "M 6.0324999,3.1749998 C 6.0541069,3.0937485 6.0676265,3.0099027 6.0973205,2.9312458 6.1618264,2.7603749 6.3516697,2.8095932 6.4076632,2.5296259 6.4267582,2.4341515 6.4045202,2.2900089 6.3711523,2.2010278 6.3471718,2.1370801 6.2634425,2.0811566 6.2981305,2.0002178 6.3152072,1.9603719 6.4020154,1.918003 6.4259187,1.8906851 6.4687148,1.8417752 6.5530428,1.7237298 6.5354514,1.6533643 6.5273856,1.6211009 6.3802979,1.3795445 6.3528968,1.3612771 c -0.010126,-0.00675 -0.036125,0.012164 -0.036511,0 -0.00103,-0.032407 0.022409,-0.060851 0.033614,-0.091277",
            "m 6.985,8.89 0,-4.7625 h 0.9525 l 0,4.7625",
            "M 7.3024999,3.81 C 7.333127,3.6404341 7.2708848,3.3720431 7.411713,3.2312147 7.4639106,3.1790171 7.5683599,3.2206128 7.612523,3.1764483 7.7161558,3.0728155 7.5602427,3.0200012 7.8315883,2.9573831 7.9183441,2.9373621 8.192854,2.902857 8.2514637,2.8295949 8.2867166,2.7855285 8.2167589,2.6133359 8.2332075,2.5557631 8.259306,2.4644209 8.4198099,2.2890352 8.5070393,2.2454204 c 0.010885,-0.00544 0.027905,0.00861 0.036511,0 0.066905,-0.066905 -0.0081,-0.2312758 0.018256,-0.3103426 C 8.5679157,1.9167506 8.6920246,1.7009164 8.6895944,1.6977569 8.6569104,1.6552605 8.6115315,1.6242523 8.5724999,1.5875",
            "M 7.6199999,3.81 C 7.7452957,3.726604 7.8809106,3.6569427 7.9958874,3.5598129 c 0.013147,-0.011107 -0.026964,-0.022191 -0.036511,-0.036511 -0.00863,-0.012941 -0.034668,-0.074864 -0.018256,-0.091277 0.054427,-0.054427 0.1460436,-0.048681 0.2190655,-0.073022 0.053237,-0.017746 0.1085858,-0.066057 0.1642991,-0.073022 0.048305,-0.00604 0.1025017,0.02177 0.1460436,0 C 8.5186556,3.2619169 8.324485,3.1174318 8.324485,3.1399375 c 0,0.029681 0.035889,-0.054455 0.073022,-0.073022 0.2738969,-0.1369486 -0.011943,0.033186 0.073022,-0.073022 0.076697,-0.095871 0.070812,-0.00721 0.091277,-0.1095327 0.00647,-0.032354 -0.019947,-0.1078421 0,-0.1277882 0.1015262,-0.1015262 0.2645537,-0.1295236 0.3833643,-0.20081 0.011668,-0.007 0.00863,-0.026889 0.018256,-0.036511 0.021513,-0.021514 0.048096,-0.037318 0.073022,-0.054766 0.035948,-0.025164 0.080975,-0.039705 0.1095327,-0.073022 C 9.180679,2.3509826 9.108633,2.2550343 9.091215,2.2271645 9.051668,2.1638885 9.017926,2.0983078 8.999938,2.0263545 c -0.010314,-0.041257 0.014928,-0.08674 0,-0.1277881 C 8.9158161,1.6672342 8.9269484,1.8419652 8.8899999,1.5875"
        ]
    },
    {
        id: 'museum',
        name: 'Museum',
        level: 3,
        land: 'plains',
        requirements: [['archeological-dig', 'university']],
        ancestor: 'school',
        image: [
            "M 2.2225,10.16 2.54,9.8424999 H 3.81 L 4.1274999,10.16 Z",
            "m 2.54,9.8424999 v -4.7625 h 1.27 v 4.7625",
            "m 2.54,5.0799999 -0.3175,-0.3175 H 4.1274999 L 3.81,5.0799999",
            "M 8.5725,10.16 8.89,9.8425003 h 1.27 L 10.4775,10.16 Z",
            "M 8.89,9.8425003 V 5.08 h 1.27 v 4.7625003",
            "M 8.89,5.08 8.5725,4.7625 h 1.905 L 10.16,5.08",
            "M 1.27,4.7624999 H 11.43 L 6.3499999,1.27 Z",
            "M 1.905,4.7624999 V 10.16",
            "M 10.795,4.7624999 V 10.16",
            "m 4.1274999,10.16 h 4.445",
            "m 4.4449999,9.5249999 h 3.81",
            "m 4.7624999,8.8899999 h 3.175",
            "m 5.0799999,8.2549999 v -2.54 h 2.54 v 2.54",
            "M 6.3499999,1.905 3.175,4.1275 h 6.35 z",
            "M 3.81,8.255 H 8.89"
        ]
    },
    {
        id: 'automotive-plant',
        name: 'Automotive plant',
        level: 3,
        land: 'plains',
        requirements: [['oil-rig', 'factory']],
        ancestor: 'facility',
        image: [
            "M 3.1785411,7.2399604 C 2.9165663,7.1950143 2.6727658,7.1177657 2.5399999,6.9849999 v 0 -0.9525 L 2.8575,5.08 C 4.3986976,4.4727422 6.0324999,4.7625 6.3499999,4.7625 c 0.3175,0 0.9083384,0.7207636 1.27,1.2699999 h 1.5875 c 0.3175,0 0.3175,0 0.3175,0.3175 v 0.9525 H 8.8899083",
            "M 7.6202428,7.3024999 H 4.4453037",
            "M 8.89,7.3025 A 0.63499999,0.63499999 0 0 1 8.255,7.9375 0.63499999,0.63499999 0 0 1 7.6200001,7.3025 0.63499999,0.63499999 0 0 1 8.255,6.6675 0.63499999,0.63499999 0 0 1 8.89,7.3025 Z",
            "m 4.4449999,7.3025 a 0.63499999,0.63499999 0 0 1 -0.635,0.635 A 0.63499999,0.63499999 0 0 1 3.175,7.3025 a 0.63499999,0.63499999 0 0 1 0.6349999,-0.635 0.63499999,0.63499999 0 0 1 0.635,0.635 z",
            "M 2.8575,5.715 C 3.1101619,5.7992206 3.5881432,5.9638306 4.120049,5.9840177 5.3975,6.0325 7.6199999,6.0324999 7.6199999,6.0324999",
            "M 5.3975,4.7625001 V 6.0324999",
            "M 1.27,7.9374999 H 11.43"
        ]
    },
    {
        id: 'train-station',
        name: 'Train station',
        level: 3,
        land: 'plains',
        requirements: [['automotive-plant', 'coal-powerplant'], ['automotive-plant', 'nuclear-powerplant'], ['automotive-plant', 'wind-turbine']],
        ancestor: 'facility',
        image: [
            "M 4.4411353,7.7595179 A 0.15875,0.63499999 0 0 1 4.2862501,8.2552569 0.15875,0.63499999 0 0 1 4.1286349,7.6960473",
            "m 5.08,3.810257 h 2.54 c 0.3175001,0.3175 0.6350001,0.9525 0.635,1.5874999 -1.2713466,0.4241165 -2.5413417,0.4225498 -3.81,0 C 4.4450001,4.762757 4.7625001,4.127757 5.08,3.810257 Z",
            "m 6.35,6.3502569 v 0.9525",
            "m 7.9375001,6.350257 c 0.3175001,0.3175001 0.3175001,0.6350001 0,0.9525",
            "m 4.7625001,6.350257 c -0.1868651,0.3266208 -0.3174999,0.6350001 0,0.9525",
            "M 3.4925001,8.8902569 H 9.2075",
            "m 8.2550001,8.255257 h -3.81",
            "M 5.08,7.9377569 H 7.62",
            "m 3.8100001,7.6202569 c 1.7275141,0.4374385 3.4186278,0.4090318 5.0799999,0 l 0.3175,-0.3175 C 9.8425001,5.715257 8.2550001,3.492757 7.6200001,3.492757 h -2.54 c -0.635,0 -2.2225,2.2225 -1.5875,3.8099999 z",
            "m 8.2664871,7.759518 a 0.15875,0.63499999 0 0 0 0.154885,0.4957389 0.15875,0.63499999 0 0 0 0.157616,-0.5592096",
            "m 1.905,9.8424999 h 8.89",
            "M 5.0799999,7.9374999 1.905,9.8424999 v -0.3175 l 3.1749999,-1.5875",
            "m 7.6199999,7.9374999 3.1750001,1.905 v -0.3175 z"
        ]
    },
    {
        id: 'archeological-dig',
        name: 'Archeological dig',
        level: 3,
        land: 'plains',
        resource: 'burial-site',
        image: [
            "M 10.047474,6.0613186 10.683878,7.856873 10.08536,8.0690076 9.448956,6.2734532 Z",
            "M 9.448956,6.2734532 C 8.3768539,5.7658804 7.5722295,6.0296918 7.0548827,7.1219916 l 0.636404,1.7955546 C 8.0005899,8.8079182 8.6202959,8.4217898 8.5838579,8.6933652 8.5019379,9.3039296 9.065306,8.7757152 9.230796,9.039808 9.426936,9.352818 9.8539,8.5715342 10.08536,8.0690076",
            "m 1.9748827,7.8736262 1.2454408,-0.24855 C 4.2393607,8.1050622 5.0621659,8.2858552 5.0884847,7.252251 L 4.8399347,6.0068104 C 4.3168943,4.9456176 3.6374857,5.7440692 2.9717735,6.3796354 L 1.7263327,6.6281856 Z",
            "m 5.9488525,2.8499622 v 1.27 l -0.635,0.635 c -0.165656,0.3914738 -0.079518,0.8042082 0.635,1.2700002 h 0.635 c 0.4489228,-0.3588408 0.9121638,-0.7137894 0.635,-1.2700002 l -0.635,-0.635 v -1.27 z",
            "m 4.731625,9.0913479 0.632631,-0.054799 1.2652622,-0.109598 -0.288916,0.343715 -0.9489467,0.082199 c -0.635,0.077581 -0.3175,-0.2399192 -0.6600305,-0.2615165 z",
            "m 7.9066249,9.4088478 0.3175,-0.3175 0.3175,0.3175 c 0.1304142,0.3171041 0.136492,0.5189501 -0.635,0 z",
            "m 3.7791249,5.5988478 v 0.635 l 0.3175,0.3175 -0.3175,0.3175"
        ]
    },
    {
        id: 'oil-rig',
        name: 'Oil rig',
        level: 3,
        land: 'water',
        resource: 'oil',
        image: [
            "m 2.54,5.0799999 h 7.62 v 0.3175 H 2.54 Z",
            "m 3.175,9.0222915 0,-3.6247915 h 1.27 l 0,3.81",
            "m 9.525,9.0222915 0,-3.6247915 h -1.27 v 3.81",
            "M 3.175,5.0799999 4.1275,1.905 H 4.445 l 0.9524999,3.1749999",
            "M 4.7624999,2.8575 3.4925,4.1274999 l 0.9524999,0.9525",
            "m 3.81,2.8575 1.2699999,1.2699999 -0.9525,0.9525",
            "m 5.08,4.445 4.4449999,-1e-7 0.3175,0.635",
            "M 6.6674999,4.4449999 6.9849999,2.54 h 0.3175 l 0.3175,1.9049999",
            "m 7.3024999,2.54 h 1.905 v 0.635",
            "M 2.54,8.8899999 C 3.2051324,8.9822642 4.0015654,9.1683054 4.5480899,9.0593456 5.3975,8.89 5.3871189,8.952185 6.7490951,9.1475928 7.2215332,9.2153753 7.4532302,9.2270817 8.1925665,9.1812168 9.0128453,9.1303306 9.6829035,8.7940934 10.4775,8.8899999"        ]
    },
    {
        id: 'coal-mine',
        name: 'Coal mine',
        level: 3,
        land: 'hills',
        resource: 'coal',
        image: [
            "m 8.2549999,8.2550001 a 0.63499999,0.63499999 0 0 1 -0.635,0.635 0.63499999,0.63499999 0 0 1 -0.635,-0.635 0.63499999,0.63499999 0 0 1 0.635,-0.635 0.63499999,0.63499999 0 0 1 0.635,0.635 z",
            "M 3.81,5.0799999 C 3.5841609,5.0038333 3.5811896,5.0636196 3.6145792,4.7464172 c 0.00909,-0.086334 0.1562651,-0.1173215 0.2190655,-0.1277881 0.024008,-0.004 0.05581,-0.017211 0.073022,0 0.0043,0.0043 0,0.024342 0,0.018256 0,-0.2916626 0.1594496,-0.3475463 0.4198753,-0.3103428 0.097697,0.013957 0.1048639,0.00815 0.1825545,0.054766 0.067621,0.040572 -0.022691,0.092267 0.036511,0.1277882 0.093514,0.056108 0.2453077,0.072451 0.2738319,0.20081 0.016349,0.073564 0.016819,0.261321 0,0.328598 -0.0061,0.02441 0.00266,0.073642 0,0.073022 -0.021129,-0.00493 -0.03796,-0.021018 -0.056939,-0.031527",
            "M 4.7624999,4.7624999 C 6.8657956,3.7183441 5.4132654,4.0623622 5.7139561,4.3630527 c 0.0043,0.0043 -0.00193,-0.012483 0,-0.018256 0.00959,-0.028777 0.052334,-0.1493208 0.091277,-0.1642991 0.1457357,-0.056052 0.2988829,0.00106 0.3833643,0.1277882 0.058896,0.088344 0.1093878,0.2195005 0.073022,0.3285982 -0.00406,0.012176 -0.2452624,0.1158759 -0.237321,0.1277882 0.046456,0.069684 0.047318,0.010806 0.091277,0.054766 0.0043,0.0043 -0.00506,0.01488 0,0.018256 0.016013,0.010673 0.069033,0.031169 0.054766,0.018256 -0.041156,-0.037252 -0.091895,-0.062301 -0.1378424,-0.093451",
            "M 6.3499999,4.4449999 C 6.6567512,4.6659511 7.150528,4.3939549 7.411713,4.65514 7.511567,4.754994 7.453948,4.8001001 7.484735,4.8924609 7.509109,4.9655819 7.572794,5.0190698 7.62,5.0799999",
            "M 7.9374999,5.0799999 C 7.7531636,4.7426064 7.4414461,4.3315717 7.5395012,3.9066665 7.5568764,3.8313743 7.723811,3.798889 7.7768219,3.8519002 c 0.042286,0.042286 -0.1394934,0.00119 0.054766,0.036511 0.2149832,0.039088 0.085785,-0.013346 0.3103427,0.073022 0.06569,0.025265 0.081771,0.024731 0.091277,0.091277 0.00803,0.056226 -0.00604,0.091277 0,0.091277 0.013608,0 0.02331,-0.014954 0.036511,-0.018256 0.045322,-0.011329 0.1018437,0.014735 0.1460436,0 0.2039843,-0.067995 0.078777,-0.1700543 0.1095328,-0.2008097 0.02435,-0.02435 -0.019725,0.1272982 -0.018256,0.1277882 0.067028,0.022344 0.2090605,-0.010004 0.2555762,0.036511 0.040547,0.040547 0.068986,0.1054973 0.1095327,0.1460437 0.060627,0.060627 0.1217999,0.084418 0.1095327,0.1825545 -0.00798,0.063846 -0.073022,0.2091955 -0.073022,0.2555764 0,0.074197 0.071248,0.1184008 0.054766,0.20081 -0.025581,0.1279078 -0.072578,0.00408 -0.073426,0.2057953",
            "m 2.54,8.8899999 h 7.62",
            "m 5.7149999,8.2550001 a 0.63499999,0.63499999 0 0 1 -0.635,0.635 0.63499999,0.63499999 0 0 1 -0.635,-0.635 0.63499999,0.63499999 0 0 1 0.635,-0.635 0.63499999,0.63499999 0 0 1 0.635,0.635 z",
            "m 3.175,5.0797933 0.9523965,3.175 H 4.4452066 A 0.63499999,0.63499999 0 0 1 5.0797933,7.6202065 0.63499999,0.63499999 0 0 1 5.7148965,8.2547933 H 6.9851034 A 0.63499999,0.63499999 0 0 1 7.6202065,7.6202065 0.63499999,0.63499999 0 0 1 8.2547933,8.2547933 h 0.31781 l 0.9523966,-3.175 z"
        ]
    },
    {
        id: 'uranium-mine',
        name: 'Uranium mine',
        level: 3,
        land: 'mountain',
        resource: 'uranium',
        image: [
            "M 3.4925,3.175 2.54,10.16 h 7.62 L 9.2075,3.175 Z",
            "M 1.905,10.16 2.8575,3.175 h 6.985 l 0.9525,6.985",
            "M 2.8575001,2.54 V 3.175 H 9.8425 V 2.54 Z",
            "M 6.8258445,5.5871553 A 0.95249999,0.95249999 0 0 1 7.3025,6.4122784 M 7.3025,4.7625 6.826203,5.5874711 M 7.3025,6.4122784 H 8.255 M 7.3022971,4.7623831 A 1.9049999,1.9049999 0 0 1 8.255,6.4122784",
            "M 5.3975,6.4122784 A 0.95249999,0.95249999 0 0 1 5.8741395,5.5871643 M 5.3975,4.7625 5.8739265,5.5876949 m -1.4289264,0.8245836 0.9524999,-1e-7 m -0.9524999,1e-7 A 1.9049999,1.9049999 0 0 1 5.3975,4.7625",
            "M 6.8258445,7.2374013 A 0.95249999,0.95249999 0 0 1 6.35,7.3647783 0.95249999,0.95249999 0 0 1 5.8741504,7.2373993 M 5.8738064,7.2370813 5.3975,8.0620573 m 1.4287028,-0.824972 0.4762971,0.824972 m 1.891e-4,-1.1e-4 A 1.9049999,1.9049999 0 0 1 6.3500001,8.3172783 1.9049999,1.9049999 0 0 1 5.3975,8.0620573",
            "m 6.3500001,6.0947784 a 0.3175,0.3175 0 0 1 0.3175,0.3174999 0.3175,0.3175 0 0 1 -0.3175,0.3175 0.3175,0.3175 0 0 1 -0.3175,-0.3174999 0.3175,0.3175 0 0 1 0.3175,-0.3175 z"
        ]
    },
    {
        id: 'medical-lab',
        name: 'Medical lab',
        level: 3,
        land: 'forest',
        resource: 'healing-roots',
        image: [
            "m 9.2074999,3.4925 h -2.2225 0.635 v 6.35 c 0.1915846,0.342312 0.7116098,0.498137 0.9525001,0 v -6.35",
            "m 1.5874999,7.3025 h 8.255 v 3.4925 h -8.255 z",
            "m 7.6199999,4.1275 -0.3175001,-1e-7 V 2.8575 h 1.27 v -1.27 h 1.27 v 1.27 H 11.1125 V 4.1274999 H 9.8424998 v 1.27 h -1.27",
            "m 6.6674999,3.4925 h -2.2225 0.635 v 6.35 c 0.1915846,0.342312 0.7116098,0.498137 0.9525001,0 v -6.35",
            "m 4.1274999,3.4925 h -2.2225 0.635 v 6.35 c 0.1915846,0.342312 0.7116098,0.498137 0.9525001,0 v -6.35",
            "m 2.5399999,6.0324999 h 0.9525",
            "m 5.0799998,5.3974999 h 0.9525",
            "m 7.6199998,6.6674999 h 0.9525"
        ]
    },
    {
        id: 'national-park',
        name: 'National park',
        level: 3,
        land: 'forest',
        resource: 'rare-animals',
        image: [
            "M 6.3499999,9.8424999 C 4.445,9.2075 3.175,6.0325 3.175,3.4925 4.2588584,3.6473369 5.3317494,2.8617906 6.3382364,2.8656073 7.3955959,2.8696168 8.3863584,3.6551631 9.525,3.4925 c 0,2.54 -1.27,5.715 -3.1750001,6.3499999 z",
            "M 6.0325,7.62 V 6.985 H 5.08 L 5.7150001,6.0325001 h -0.3175 l 0.635,-0.9525 h -0.3175 l 0.635,-0.9525 0.635,0.9525 h -0.3175 L 7.3025,6.0325 6.9850001,6.0325001 7.62,6.985 H 6.6675 V 7.62 Z"
        ]
    }
];

const makeAdvancements = () => {
    return {
        getAvailableAdvancements: (land, current, resource) => {
            return advancements.filter(
                a => a.land === land && (!current && !a.ancestor || current === a.ancestor) && (!resource && !a.resource || resource === a.resource));
        },

        getAdvancement: id => {
            return advancements.find(a => a.id === id);
        },

        getAllWithFulfilledRequirements: (knownAdvancements, knownResources) =>
            advancements.map(a => {
                const req = (a.requirements || [[]]);
                if (!a.resource || (knownResources || []).includes(a.resource)) {
                    for (let reqSet of req) {
                        if (reqSet.every(r => knownAdvancements.includes(r))) {
                            return {
                                advancement: a,
                                match: reqSet
                            };
                        }
                    }
                }
                return null;
            }).filter(r => r !== null),
        
        getAdvancementsForResource: resource => advancements.filter(a => a.resource === resource),
        
        getAll: () => [...advancements],

        getAllAdvancementsRequiring: advancementId => advancements.filter(a => a.requirements && a.requirements.some(r => r.includes(advancementId))),

        getAllAdvancementsDescendingFrom: advancementId => advancements.filter(a => a.ancestor === advancementId)
    };
};

export default makeAdvancements;